<template>
  <div>
    <v-dialog v-model="dialog" eager persistent scrollable fullscreen>
      <v-form ref="EvaluationFormRef" @submit.prevent>
        <v-card>
          <v-card-title class="d-flex align-center">
            <span
              >{{ action == "Add" ? "Create" : "Update" }} Evaluation for
              {{ name }}
            </span>
            <v-spacer></v-spacer>
            <v-btn icon="mdi-close" variant="text" @click="closeD()"> </v-btn>
          </v-card-title>

          <v-card-text style="max-height: 700px" class="">
            <!-- BSIT/BSIS -->
            <v-container v-if="['1', '2'].includes(getProgramID)">
              <v-row>
                <v-col cols="12">
                  <div class="rounded-lg pa-2 border border-1">
                    <div class="text-justify text-subtitle-1">
                      <p>
                        Please complete this evaluation form and submit it
                        directly to the college's OJT coordinator. Please verify
                        the rating that corresponds to your assessment of the
                        student trainee in the applicable competency.
                      </p>
                      <p>
                        Thank you for your time and contributions in making each
                        student’s practicum a valuable and interesting
                        experience.
                      </p>

                      <div class="text-subtitle-1 font-weight-bold mt-4">
                        Rating Legend:
                      </div>
                      <div class="">
                        <div class="d-flex ga-4">
                          <div class="text-subtitle-1 font-weight-bold">5</div>
                          <div class="text-subtitle-1 font-weight-bold">=</div>
                          <div class="text-subtitle-1">
                            <span class="font-weight-bold">Excellent</span> -
                            Consistently exceeds expectations
                          </div>
                        </div>
                        <div class="d-flex ga-4">
                          <div class="text-subtitle-1 font-weight-bold">4</div>
                          <div class="text-subtitle-1 font-weight-bold">=</div>
                          <div class="text-subtitle-1">
                            <span class="font-weight-bold">Very Good</span> -
                            Frequently exceeds expectations
                          </div>
                        </div>
                        <div class="d-flex ga-4">
                          <div class="text-subtitle-1 font-weight-bold">3</div>
                          <div class="text-subtitle-1 font-weight-bold">=</div>
                          <div class="text-subtitle-1">
                            <span class="font-weight-bold">Satisfactory</span> -
                            Meets expectations
                          </div>
                        </div>
                        <div class="d-flex ga-4">
                          <div class="text-subtitle-1 font-weight-bold">2</div>
                          <div class="text-subtitle-1 font-weight-bold">=</div>
                          <div class="text-subtitle-1">
                            <span class="font-weight-bold"
                              >Needs Improvement</span
                            >
                            - Occasionally meets expectations
                          </div>
                        </div>
                        <div class="d-flex ga-4">
                          <div class="text-subtitle-1 font-weight-bold">1</div>
                          <div class="text-subtitle-1 font-weight-bold">=</div>
                          <div class="text-subtitle-1">
                            <span class="font-weight-bold">Poor</span> - Does
                            not meet Expectations
                          </div>
                        </div>
                        <div class="d-flex ga-4">
                          <div class="text-subtitle-1 font-weight-bold">NA</div>
                          <div class="text-subtitle-1 font-weight-bold">=</div>
                          <div class="text-subtitle-1">
                            <span class="font-weight-bold">Not applicable</span>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </v-col>
                <v-col cols="12">
                  <table class="tbl">
                    <tbody>
                      <tr>
                        <td
                          colspan="7"
                          class="text-subtitle-1 font-weight-bold px-1"
                        >
                          A. PROFESSIONAL ATTITUDE AND WORK ETHICS
                        </td>
                      </tr>
                      <tr>
                        <td width="70%"></td>
                        <td width="5%" align="center" class="text-subtitle-1">
                          5
                        </td>
                        <td width="5%" align="center" class="text-subtitle-1">
                          4
                        </td>
                        <td width="5%" align="center" class="text-subtitle-1">
                          3
                        </td>
                        <td width="5%" align="center" class="text-subtitle-1">
                          2
                        </td>
                        <td width="5%" align="center" class="text-subtitle-1">
                          1
                        </td>
                        <td width="5%" align="center" class="text-subtitle-1">
                          NA
                        </td>
                      </tr>
                      <!-- A -->
                      <tr>
                        <td class="px-1">
                          {{ evalData && evalData.a_1.question }}
                        </td>
                        <td align="center" class="text-subtitle-1 pa-2">
                          <div
                            class="d-flex justify-center align-center border border-1 radio"
                            :class="
                              evalData && evalData.a_1.evalAns == 5
                                ? 'bg-green'
                                : ''
                            "
                            @click="evalData.a_1.evalAns = 5"
                          >
                            5
                          </div>
                        </td>
                        <td align="center" class="text-subtitle-1 pa-2">
                          <div
                            class="d-flex justify-center align-center border border-1 radio"
                            :class="
                              evalData && evalData.a_1.evalAns == 4
                                ? 'bg-green'
                                : ''
                            "
                            @click="evalData.a_1.evalAns = 4"
                          >
                            4
                          </div>
                        </td>
                        <td align="center" class="text-subtitle-1 pa-2">
                          <div
                            class="d-flex justify-center align-center border border-1 radio"
                            :class="
                              evalData && evalData.a_1.evalAns == 3
                                ? 'bg-green'
                                : ''
                            "
                            @click="evalData.a_1.evalAns = 3"
                          >
                            3
                          </div>
                        </td>
                        <td align="center" class="text-subtitle-1 pa-2">
                          <div
                            class="d-flex justify-center align-center border border-1 radio"
                            :class="
                              evalData && evalData.a_1.evalAns == 2
                                ? 'bg-green'
                                : ''
                            "
                            @click="evalData.a_1.evalAns = 2"
                          >
                            2
                          </div>
                        </td>
                        <td align="center" class="text-subtitle-1 pa-2">
                          <div
                            class="d-flex justify-center align-center border border-1 radio"
                            :class="
                              evalData && evalData.a_1.evalAns == 1
                                ? 'bg-green'
                                : ''
                            "
                            @click="evalData.a_1.evalAns = 1"
                          >
                            1
                          </div>
                        </td>
                        <td align="center" class="text-subtitle-1 pa-2">
                          <div
                            class="d-flex justify-center align-center border border-1 radio"
                            :class="
                              evalData && evalData.a_1.evalAns == 'NA'
                                ? 'bg-green'
                                : ''
                            "
                            @click="evalData.a_1.evalAns = 'NA'"
                          >
                            NA
                          </div>
                        </td>
                      </tr>
                      <tr>
                        <td class="px-1">
                          {{ evalData && evalData.a_2.question }}
                        </td>
                        <td align="center" class="text-subtitle-1 pa-2">
                          <div
                            class="d-flex justify-center align-center border border-1 radio"
                            :class="
                              evalData && evalData.a_2.evalAns == 5
                                ? 'bg-green'
                                : ''
                            "
                            @click="evalData.a_2.evalAns = 5"
                          >
                            5
                          </div>
                        </td>
                        <td align="center" class="text-subtitle-1 pa-2">
                          <div
                            class="d-flex justify-center align-center border border-1 radio"
                            :class="
                              evalData && evalData.a_2.evalAns == 4
                                ? 'bg-green'
                                : ''
                            "
                            @click="evalData.a_2.evalAns = 4"
                          >
                            4
                          </div>
                        </td>
                        <td align="center" class="text-subtitle-1 pa-2">
                          <div
                            class="d-flex justify-center align-center border border-1 radio"
                            :class="
                              evalData && evalData.a_2.evalAns == 3
                                ? 'bg-green'
                                : ''
                            "
                            @click="evalData.a_2.evalAns = 3"
                          >
                            3
                          </div>
                        </td>
                        <td align="center" class="text-subtitle-1 pa-2">
                          <div
                            class="d-flex justify-center align-center border border-1 radio"
                            :class="
                              evalData && evalData.a_2.evalAns == 2
                                ? 'bg-green'
                                : ''
                            "
                            @click="evalData.a_2.evalAns = 2"
                          >
                            2
                          </div>
                        </td>
                        <td align="center" class="text-subtitle-1 pa-2">
                          <div
                            class="d-flex justify-center align-center border border-1 radio"
                            :class="
                              evalData && evalData.a_2.evalAns == 1
                                ? 'bg-green'
                                : ''
                            "
                            @click="evalData.a_2.evalAns = 1"
                          >
                            1
                          </div>
                        </td>
                        <td align="center" class="text-subtitle-1 pa-2">
                          <div
                            class="d-flex justify-center align-center border border-1 radio"
                            :class="
                              evalData && evalData.a_2.evalAns == 'NA'
                                ? 'bg-green'
                                : ''
                            "
                            @click="evalData.a_2.evalAns = 'NA'"
                          >
                            NA
                          </div>
                        </td>
                      </tr>
                      <tr>
                        <td class="px-1">
                          {{ evalData && evalData.a_3.question }}
                        </td>
                        <td align="center" class="text-subtitle-1 pa-2">
                          <div
                            class="d-flex justify-center align-center border border-1 radio"
                            :class="
                              evalData && evalData.a_3.evalAns == 5
                                ? 'bg-green'
                                : ''
                            "
                            @click="evalData.a_3.evalAns = 5"
                          >
                            5
                          </div>
                        </td>
                        <td align="center" class="text-subtitle-1 pa-2">
                          <div
                            class="d-flex justify-center align-center border border-1 radio"
                            :class="
                              evalData && evalData.a_3.evalAns == 4
                                ? 'bg-green'
                                : ''
                            "
                            @click="evalData.a_3.evalAns = 4"
                          >
                            4
                          </div>
                        </td>
                        <td align="center" class="text-subtitle-1 pa-2">
                          <div
                            class="d-flex justify-center align-center border border-1 radio"
                            :class="
                              evalData && evalData.a_3.evalAns == 3
                                ? 'bg-green'
                                : ''
                            "
                            @click="evalData.a_3.evalAns = 3"
                          >
                            3
                          </div>
                        </td>
                        <td align="center" class="text-subtitle-1 pa-2">
                          <div
                            class="d-flex justify-center align-center border border-1 radio"
                            :class="
                              evalData && evalData.a_3.evalAns == 2
                                ? 'bg-green'
                                : ''
                            "
                            @click="evalData.a_3.evalAns = 2"
                          >
                            2
                          </div>
                        </td>
                        <td align="center" class="text-subtitle-1 pa-2">
                          <div
                            class="d-flex justify-center align-center border border-1 radio"
                            :class="
                              evalData && evalData.a_3.evalAns == 1
                                ? 'bg-green'
                                : ''
                            "
                            @click="evalData.a_3.evalAns = 1"
                          >
                            1
                          </div>
                        </td>
                        <td align="center" class="text-subtitle-1 pa-2">
                          <div
                            class="d-flex justify-center align-center border border-1 radio"
                            :class="
                              evalData && evalData.a_3.evalAns == 'NA'
                                ? 'bg-green'
                                : ''
                            "
                            @click="evalData.a_3.evalAns = 'NA'"
                          >
                            NA
                          </div>
                        </td>
                      </tr>
                      <tr>
                        <td class="px-1">
                          {{ evalData && evalData.a_4.question }}
                        </td>
                        <td align="center" class="text-subtitle-1 pa-2">
                          <div
                            class="d-flex justify-center align-center border border-1 radio"
                            :class="
                              evalData && evalData.a_4.evalAns == 5
                                ? 'bg-green'
                                : ''
                            "
                            @click="evalData.a_4.evalAns = 5"
                          >
                            5
                          </div>
                        </td>
                        <td align="center" class="text-subtitle-1 pa-2">
                          <div
                            class="d-flex justify-center align-center border border-1 radio"
                            :class="
                              evalData && evalData.a_4.evalAns == 4
                                ? 'bg-green'
                                : ''
                            "
                            @click="evalData.a_4.evalAns = 4"
                          >
                            4
                          </div>
                        </td>
                        <td align="center" class="text-subtitle-1 pa-2">
                          <div
                            class="d-flex justify-center align-center border border-1 radio"
                            :class="
                              evalData && evalData.a_4.evalAns == 3
                                ? 'bg-green'
                                : ''
                            "
                            @click="evalData.a_4.evalAns = 3"
                          >
                            3
                          </div>
                        </td>
                        <td align="center" class="text-subtitle-1 pa-2">
                          <div
                            class="d-flex justify-center align-center border border-1 radio"
                            :class="
                              evalData && evalData.a_4.evalAns == 2
                                ? 'bg-green'
                                : ''
                            "
                            @click="evalData.a_4.evalAns = 2"
                          >
                            2
                          </div>
                        </td>
                        <td align="center" class="text-subtitle-1 pa-2">
                          <div
                            class="d-flex justify-center align-center border border-1 radio"
                            :class="
                              evalData && evalData.a_4.evalAns == 1
                                ? 'bg-green'
                                : ''
                            "
                            @click="evalData.a_4.evalAns = 1"
                          >
                            1
                          </div>
                        </td>
                        <td align="center" class="text-subtitle-1 pa-2">
                          <div
                            class="d-flex justify-center align-center border border-1 radio"
                            :class="
                              evalData && evalData.a_4.evalAns == 'NA'
                                ? 'bg-green'
                                : ''
                            "
                            @click="evalData.a_4.evalAns = 'NA'"
                          >
                            NA
                          </div>
                        </td>
                      </tr>
                      <tr>
                        <td class="px-1">
                          {{ evalData && evalData.a_5.question }}
                        </td>
                        <td align="center" class="text-subtitle-1 pa-2">
                          <div
                            class="d-flex justify-center align-center border border-1 radio"
                            :class="
                              evalData && evalData.a_5.evalAns == 5
                                ? 'bg-green'
                                : ''
                            "
                            @click="evalData.a_5.evalAns = 5"
                          >
                            5
                          </div>
                        </td>
                        <td align="center" class="text-subtitle-1 pa-2">
                          <div
                            class="d-flex justify-center align-center border border-1 radio"
                            :class="
                              evalData && evalData.a_5.evalAns == 4
                                ? 'bg-green'
                                : ''
                            "
                            @click="evalData.a_5.evalAns = 4"
                          >
                            4
                          </div>
                        </td>
                        <td align="center" class="text-subtitle-1 pa-2">
                          <div
                            class="d-flex justify-center align-center border border-1 radio"
                            :class="
                              evalData && evalData.a_5.evalAns == 3
                                ? 'bg-green'
                                : ''
                            "
                            @click="evalData.a_5.evalAns = 3"
                          >
                            3
                          </div>
                        </td>
                        <td align="center" class="text-subtitle-1 pa-2">
                          <div
                            class="d-flex justify-center align-center border border-1 radio"
                            :class="
                              evalData && evalData.a_5.evalAns == 2
                                ? 'bg-green'
                                : ''
                            "
                            @click="evalData.a_5.evalAns = 2"
                          >
                            2
                          </div>
                        </td>
                        <td align="center" class="text-subtitle-1 pa-2">
                          <div
                            class="d-flex justify-center align-center border border-1 radio"
                            :class="
                              evalData && evalData.a_5.evalAns == 1
                                ? 'bg-green'
                                : ''
                            "
                            @click="evalData.a_5.evalAns = 1"
                          >
                            1
                          </div>
                        </td>
                        <td align="center" class="text-subtitle-1 pa-2">
                          <div
                            class="d-flex justify-center align-center border border-1 radio"
                            :class="
                              evalData && evalData.a_5.evalAns == 'NA'
                                ? 'bg-green'
                                : ''
                            "
                            @click="evalData.a_5.evalAns = 'NA'"
                          >
                            NA
                          </div>
                        </td>
                      </tr>
                      <!-- A -->
                      <!-- B -->
                      <tr>
                        <td
                          colspan="7"
                          class="text-subtitle-1 font-weight-bold px-1"
                        >
                          B. COMMUNICATION AND INTERPERSONAL SKILLS
                        </td>
                      </tr>
                      <tr>
                        <td class="px-1">
                          {{ evalData && evalData.b_1.question }}
                        </td>
                        <td align="center" class="text-subtitle-1 pa-2">
                          <div
                            class="d-flex justify-center align-center border border-1 radio"
                            :class="
                              evalData && evalData.b_1.evalAns == 5
                                ? 'bg-green'
                                : ''
                            "
                            @click="evalData.b_1.evalAns = 5"
                          >
                            5
                          </div>
                        </td>
                        <td align="center" class="text-subtitle-1 pa-2">
                          <div
                            class="d-flex justify-center align-center border border-1 radio"
                            :class="
                              evalData && evalData.b_1.evalAns == 4
                                ? 'bg-green'
                                : ''
                            "
                            @click="evalData.b_1.evalAns = 4"
                          >
                            4
                          </div>
                        </td>
                        <td align="center" class="text-subtitle-1 pa-2">
                          <div
                            class="d-flex justify-center align-center border border-1 radio"
                            :class="
                              evalData && evalData.b_1.evalAns == 3
                                ? 'bg-green'
                                : ''
                            "
                            @click="evalData.b_1.evalAns = 3"
                          >
                            3
                          </div>
                        </td>
                        <td align="center" class="text-subtitle-1 pa-2">
                          <div
                            class="d-flex justify-center align-center border border-1 radio"
                            :class="
                              evalData && evalData.b_1.evalAns == 2
                                ? 'bg-green'
                                : ''
                            "
                            @click="evalData.b_1.evalAns = 2"
                          >
                            2
                          </div>
                        </td>
                        <td align="center" class="text-subtitle-1 pa-2">
                          <div
                            class="d-flex justify-center align-center border border-1 radio"
                            :class="
                              evalData && evalData.b_1.evalAns == 1
                                ? 'bg-green'
                                : ''
                            "
                            @click="evalData.b_1.evalAns = 1"
                          >
                            1
                          </div>
                        </td>
                        <td align="center" class="text-subtitle-1 pa-2">
                          <div
                            class="d-flex justify-center align-center border border-1 radio"
                            :class="
                              evalData && evalData.b_1.evalAns == 'NA'
                                ? 'bg-green'
                                : ''
                            "
                            @click="evalData.b_1.evalAns = 'NA'"
                          >
                            NA
                          </div>
                        </td>
                      </tr>
                      <tr>
                        <td class="px-1">
                          {{ evalData && evalData.b_2.question }}
                        </td>
                        <td align="center" class="text-subtitle-1 pa-2">
                          <div
                            class="d-flex justify-center align-center border border-1 radio"
                            :class="
                              evalData && evalData.b_2.evalAns == 5
                                ? 'bg-green'
                                : ''
                            "
                            @click="evalData.b_2.evalAns = 5"
                          >
                            5
                          </div>
                        </td>
                        <td align="center" class="text-subtitle-1 pa-2">
                          <div
                            class="d-flex justify-center align-center border border-1 radio"
                            :class="
                              evalData && evalData.b_2.evalAns == 4
                                ? 'bg-green'
                                : ''
                            "
                            @click="evalData.b_2.evalAns = 4"
                          >
                            4
                          </div>
                        </td>
                        <td align="center" class="text-subtitle-1 pa-2">
                          <div
                            class="d-flex justify-center align-center border border-1 radio"
                            :class="
                              evalData && evalData.b_2.evalAns == 3
                                ? 'bg-green'
                                : ''
                            "
                            @click="evalData.b_2.evalAns = 3"
                          >
                            3
                          </div>
                        </td>
                        <td align="center" class="text-subtitle-1 pa-2">
                          <div
                            class="d-flex justify-center align-center border border-1 radio"
                            :class="
                              evalData && evalData.b_2.evalAns == 2
                                ? 'bg-green'
                                : ''
                            "
                            @click="evalData.b_2.evalAns = 2"
                          >
                            2
                          </div>
                        </td>
                        <td align="center" class="text-subtitle-1 pa-2">
                          <div
                            class="d-flex justify-center align-center border border-1 radio"
                            :class="
                              evalData && evalData.b_2.evalAns == 1
                                ? 'bg-green'
                                : ''
                            "
                            @click="evalData.b_2.evalAns = 1"
                          >
                            1
                          </div>
                        </td>
                        <td align="center" class="text-subtitle-1 pa-2">
                          <div
                            class="d-flex justify-center align-center border border-1 radio"
                            :class="
                              evalData && evalData.b_2.evalAns == 'NA'
                                ? 'bg-green'
                                : ''
                            "
                            @click="evalData.b_2.evalAns = 'NA'"
                          >
                            NA
                          </div>
                        </td>
                      </tr>
                      <tr>
                        <td class="px-1">
                          {{ evalData && evalData.b_3.question }}
                        </td>
                        <td align="center" class="text-subtitle-1 pa-2">
                          <div
                            class="d-flex justify-center align-center border border-1 radio"
                            :class="
                              evalData && evalData.b_3.evalAns == 5
                                ? 'bg-green'
                                : ''
                            "
                            @click="evalData.b_3.evalAns = 5"
                          >
                            5
                          </div>
                        </td>
                        <td align="center" class="text-subtitle-1 pa-2">
                          <div
                            class="d-flex justify-center align-center border border-1 radio"
                            :class="
                              evalData && evalData.b_3.evalAns == 4
                                ? 'bg-green'
                                : ''
                            "
                            @click="evalData.b_3.evalAns = 4"
                          >
                            4
                          </div>
                        </td>
                        <td align="center" class="text-subtitle-1 pa-2">
                          <div
                            class="d-flex justify-center align-center border border-1 radio"
                            :class="
                              evalData && evalData.b_3.evalAns == 3
                                ? 'bg-green'
                                : ''
                            "
                            @click="evalData.b_3.evalAns = 3"
                          >
                            3
                          </div>
                        </td>
                        <td align="center" class="text-subtitle-1 pa-2">
                          <div
                            class="d-flex justify-center align-center border border-1 radio"
                            :class="
                              evalData && evalData.b_3.evalAns == 2
                                ? 'bg-green'
                                : ''
                            "
                            @click="evalData.b_3.evalAns = 2"
                          >
                            2
                          </div>
                        </td>
                        <td align="center" class="text-subtitle-1 pa-2">
                          <div
                            class="d-flex justify-center align-center border border-1 radio"
                            :class="
                              evalData && evalData.b_3.evalAns == 1
                                ? 'bg-green'
                                : ''
                            "
                            @click="evalData.b_3.evalAns = 1"
                          >
                            1
                          </div>
                        </td>
                        <td align="center" class="text-subtitle-1 pa-2">
                          <div
                            class="d-flex justify-center align-center border border-1 radio"
                            :class="
                              evalData && evalData.b_3.evalAns == 'NA'
                                ? 'bg-green'
                                : ''
                            "
                            @click="evalData.b_3.evalAns = 'NA'"
                          >
                            NA
                          </div>
                        </td>
                      </tr>
                      <tr>
                        <td class="px-1">
                          {{ evalData && evalData.b_4.question }}
                        </td>
                        <td align="center" class="text-subtitle-1 pa-2">
                          <div
                            class="d-flex justify-center align-center border border-1 radio"
                            :class="
                              evalData && evalData.b_4.evalAns == 5
                                ? 'bg-green'
                                : ''
                            "
                            @click="evalData.b_4.evalAns = 5"
                          >
                            5
                          </div>
                        </td>
                        <td align="center" class="text-subtitle-1 pa-2">
                          <div
                            class="d-flex justify-center align-center border border-1 radio"
                            :class="
                              evalData && evalData.b_4.evalAns == 4
                                ? 'bg-green'
                                : ''
                            "
                            @click="evalData.b_4.evalAns = 4"
                          >
                            4
                          </div>
                        </td>
                        <td align="center" class="text-subtitle-1 pa-2">
                          <div
                            class="d-flex justify-center align-center border border-1 radio"
                            :class="
                              evalData && evalData.b_4.evalAns == 3
                                ? 'bg-green'
                                : ''
                            "
                            @click="evalData.b_4.evalAns = 3"
                          >
                            3
                          </div>
                        </td>
                        <td align="center" class="text-subtitle-1 pa-2">
                          <div
                            class="d-flex justify-center align-center border border-1 radio"
                            :class="
                              evalData && evalData.b_4.evalAns == 2
                                ? 'bg-green'
                                : ''
                            "
                            @click="evalData.b_4.evalAns = 2"
                          >
                            2
                          </div>
                        </td>
                        <td align="center" class="text-subtitle-1 pa-2">
                          <div
                            class="d-flex justify-center align-center border border-1 radio"
                            :class="
                              evalData && evalData.b_4.evalAns == 1
                                ? 'bg-green'
                                : ''
                            "
                            @click="evalData.b_4.evalAns = 1"
                          >
                            1
                          </div>
                        </td>
                        <td align="center" class="text-subtitle-1 pa-2">
                          <div
                            class="d-flex justify-center align-center border border-1 radio"
                            :class="
                              evalData && evalData.b_4.evalAns == 'NA'
                                ? 'bg-green'
                                : ''
                            "
                            @click="evalData.b_4.evalAns = 'NA'"
                          >
                            NA
                          </div>
                        </td>
                      </tr>
                      <tr>
                        <td class="px-1">
                          {{ evalData && evalData.b_5.question }}
                        </td>
                        <td align="center" class="text-subtitle-1 pa-2">
                          <div
                            class="d-flex justify-center align-center border border-1 radio"
                            :class="
                              evalData && evalData.b_5.evalAns == 5
                                ? 'bg-green'
                                : ''
                            "
                            @click="evalData.b_5.evalAns = 5"
                          >
                            5
                          </div>
                        </td>
                        <td align="center" class="text-subtitle-1 pa-2">
                          <div
                            class="d-flex justify-center align-center border border-1 radio"
                            :class="
                              evalData && evalData.b_5.evalAns == 4
                                ? 'bg-green'
                                : ''
                            "
                            @click="evalData.b_5.evalAns = 4"
                          >
                            4
                          </div>
                        </td>
                        <td align="center" class="text-subtitle-1 pa-2">
                          <div
                            class="d-flex justify-center align-center border border-1 radio"
                            :class="
                              evalData && evalData.b_5.evalAns == 3
                                ? 'bg-green'
                                : ''
                            "
                            @click="evalData.b_5.evalAns = 3"
                          >
                            3
                          </div>
                        </td>
                        <td align="center" class="text-subtitle-1 pa-2">
                          <div
                            class="d-flex justify-center align-center border border-1 radio"
                            :class="
                              evalData && evalData.b_5.evalAns == 2
                                ? 'bg-green'
                                : ''
                            "
                            @click="evalData.b_5.evalAns = 2"
                          >
                            2
                          </div>
                        </td>
                        <td align="center" class="text-subtitle-1 pa-2">
                          <div
                            class="d-flex justify-center align-center border border-1 radio"
                            :class="
                              evalData && evalData.b_5.evalAns == 1
                                ? 'bg-green'
                                : ''
                            "
                            @click="evalData.b_5.evalAns = 1"
                          >
                            1
                          </div>
                        </td>
                        <td align="center" class="text-subtitle-1 pa-2">
                          <div
                            class="d-flex justify-center align-center border border-1 radio"
                            :class="
                              evalData && evalData.b_5.evalAns == 'NA'
                                ? 'bg-green'
                                : ''
                            "
                            @click="evalData.b_5.evalAns = 'NA'"
                          >
                            NA
                          </div>
                        </td>
                      </tr>
                      <!-- B -->
                      <!-- C -->
                      <tr>
                        <td
                          colspan="7"
                          class="text-subtitle-1 font-weight-bold px-1"
                        >
                          C. PRODUCTIVITY AND WORK EFFICIENCY
                        </td>
                      </tr>
                      <tr>
                        <td class="px-1">
                          {{ evalData && evalData.c_1.question }}
                        </td>
                        <td align="center" class="text-subtitle-1 pa-2">
                          <div
                            class="d-flex justify-center align-center border border-1 radio"
                            :class="
                              evalData && evalData.c_1.evalAns == 5
                                ? 'bg-green'
                                : ''
                            "
                            @click="evalData.c_1.evalAns = 5"
                          >
                            5
                          </div>
                        </td>
                        <td align="center" class="text-subtitle-1 pa-2">
                          <div
                            class="d-flex justify-center align-center border border-1 radio"
                            :class="
                              evalData && evalData.c_1.evalAns == 4
                                ? 'bg-green'
                                : ''
                            "
                            @click="evalData.c_1.evalAns = 4"
                          >
                            4
                          </div>
                        </td>
                        <td align="center" class="text-subtitle-1 pa-2">
                          <div
                            class="d-flex justify-center align-center border border-1 radio"
                            :class="
                              evalData && evalData.c_1.evalAns == 3
                                ? 'bg-green'
                                : ''
                            "
                            @click="evalData.c_1.evalAns = 3"
                          >
                            3
                          </div>
                        </td>
                        <td align="center" class="text-subtitle-1 pa-2">
                          <div
                            class="d-flex justify-center align-center border border-1 radio"
                            :class="
                              evalData && evalData.c_1.evalAns == 2
                                ? 'bg-green'
                                : ''
                            "
                            @click="evalData.c_1.evalAns = 2"
                          >
                            2
                          </div>
                        </td>
                        <td align="center" class="text-subtitle-1 pa-2">
                          <div
                            class="d-flex justify-center align-center border border-1 radio"
                            :class="
                              evalData && evalData.c_1.evalAns == 1
                                ? 'bg-green'
                                : ''
                            "
                            @click="evalData.c_1.evalAns = 1"
                          >
                            1
                          </div>
                        </td>
                        <td align="center" class="text-subtitle-1 pa-2">
                          <div
                            class="d-flex justify-center align-center border border-1 radio"
                            :class="
                              evalData && evalData.c_1.evalAns == 'NA'
                                ? 'bg-green'
                                : ''
                            "
                            @click="evalData.c_1.evalAns = 'NA'"
                          >
                            NA
                          </div>
                        </td>
                      </tr>
                      <tr>
                        <td class="px-1">
                          {{ evalData && evalData.c_2.question }}
                        </td>
                        <td align="center" class="text-subtitle-1 pa-2">
                          <div
                            class="d-flex justify-center align-center border border-1 radio"
                            :class="
                              evalData && evalData.c_2.evalAns == 5
                                ? 'bg-green'
                                : ''
                            "
                            @click="evalData.c_2.evalAns = 5"
                          >
                            5
                          </div>
                        </td>
                        <td align="center" class="text-subtitle-1 pa-2">
                          <div
                            class="d-flex justify-center align-center border border-1 radio"
                            :class="
                              evalData && evalData.c_2.evalAns == 4
                                ? 'bg-green'
                                : ''
                            "
                            @click="evalData.c_2.evalAns = 4"
                          >
                            4
                          </div>
                        </td>
                        <td align="center" class="text-subtitle-1 pa-2">
                          <div
                            class="d-flex justify-center align-center border border-1 radio"
                            :class="
                              evalData && evalData.c_2.evalAns == 3
                                ? 'bg-green'
                                : ''
                            "
                            @click="evalData.c_2.evalAns = 3"
                          >
                            3
                          </div>
                        </td>
                        <td align="center" class="text-subtitle-1 pa-2">
                          <div
                            class="d-flex justify-center align-center border border-1 radio"
                            :class="
                              evalData && evalData.c_2.evalAns == 2
                                ? 'bg-green'
                                : ''
                            "
                            @click="evalData.c_2.evalAns = 2"
                          >
                            2
                          </div>
                        </td>
                        <td align="center" class="text-subtitle-1 pa-2">
                          <div
                            class="d-flex justify-center align-center border border-1 radio"
                            :class="
                              evalData && evalData.c_2.evalAns == 1
                                ? 'bg-green'
                                : ''
                            "
                            @click="evalData.c_2.evalAns = 1"
                          >
                            1
                          </div>
                        </td>
                        <td align="center" class="text-subtitle-1 pa-2">
                          <div
                            class="d-flex justify-center align-center border border-1 radio"
                            :class="
                              evalData && evalData.c_2.evalAns == 'NA'
                                ? 'bg-green'
                                : ''
                            "
                            @click="evalData.c_2.evalAns = 'NA'"
                          >
                            NA
                          </div>
                        </td>
                      </tr>
                      <tr>
                        <td class="px-1">
                          {{ evalData && evalData.c_3.question }}
                        </td>
                        <td align="center" class="text-subtitle-1 pa-2">
                          <div
                            class="d-flex justify-center align-center border border-1 radio"
                            :class="
                              evalData && evalData.c_3.evalAns == 5
                                ? 'bg-green'
                                : ''
                            "
                            @click="evalData.c_3.evalAns = 5"
                          >
                            5
                          </div>
                        </td>
                        <td align="center" class="text-subtitle-1 pa-2">
                          <div
                            class="d-flex justify-center align-center border border-1 radio"
                            :class="
                              evalData && evalData.c_3.evalAns == 4
                                ? 'bg-green'
                                : ''
                            "
                            @click="evalData.c_3.evalAns = 4"
                          >
                            4
                          </div>
                        </td>
                        <td align="center" class="text-subtitle-1 pa-2">
                          <div
                            class="d-flex justify-center align-center border border-1 radio"
                            :class="
                              evalData && evalData.c_3.evalAns == 3
                                ? 'bg-green'
                                : ''
                            "
                            @click="evalData.c_3.evalAns = 3"
                          >
                            3
                          </div>
                        </td>
                        <td align="center" class="text-subtitle-1 pa-2">
                          <div
                            class="d-flex justify-center align-center border border-1 radio"
                            :class="
                              evalData && evalData.c_3.evalAns == 2
                                ? 'bg-green'
                                : ''
                            "
                            @click="evalData.c_3.evalAns = 2"
                          >
                            2
                          </div>
                        </td>
                        <td align="center" class="text-subtitle-1 pa-2">
                          <div
                            class="d-flex justify-center align-center border border-1 radio"
                            :class="
                              evalData && evalData.c_3.evalAns == 1
                                ? 'bg-green'
                                : ''
                            "
                            @click="evalData.c_3.evalAns = 1"
                          >
                            1
                          </div>
                        </td>
                        <td align="center" class="text-subtitle-1 pa-2">
                          <div
                            class="d-flex justify-center align-center border border-1 radio"
                            :class="
                              evalData && evalData.c_3.evalAns == 'NA'
                                ? 'bg-green'
                                : ''
                            "
                            @click="evalData.c_3.evalAns = 'NA'"
                          >
                            NA
                          </div>
                        </td>
                      </tr>
                      <tr>
                        <td class="px-1">
                          {{ evalData && evalData.c_4.question }}
                        </td>
                        <td align="center" class="text-subtitle-1 pa-2">
                          <div
                            class="d-flex justify-center align-center border border-1 radio"
                            :class="
                              evalData && evalData.c_4.evalAns == 5
                                ? 'bg-green'
                                : ''
                            "
                            @click="evalData.c_4.evalAns = 5"
                          >
                            5
                          </div>
                        </td>
                        <td align="center" class="text-subtitle-1 pa-2">
                          <div
                            class="d-flex justify-center align-center border border-1 radio"
                            :class="
                              evalData && evalData.c_4.evalAns == 4
                                ? 'bg-green'
                                : ''
                            "
                            @click="evalData.c_4.evalAns = 4"
                          >
                            4
                          </div>
                        </td>
                        <td align="center" class="text-subtitle-1 pa-2">
                          <div
                            class="d-flex justify-center align-center border border-1 radio"
                            :class="
                              evalData && evalData.c_4.evalAns == 3
                                ? 'bg-green'
                                : ''
                            "
                            @click="evalData.c_4.evalAns = 3"
                          >
                            3
                          </div>
                        </td>
                        <td align="center" class="text-subtitle-1 pa-2">
                          <div
                            class="d-flex justify-center align-center border border-1 radio"
                            :class="
                              evalData && evalData.c_4.evalAns == 2
                                ? 'bg-green'
                                : ''
                            "
                            @click="evalData.c_4.evalAns = 2"
                          >
                            2
                          </div>
                        </td>
                        <td align="center" class="text-subtitle-1 pa-2">
                          <div
                            class="d-flex justify-center align-center border border-1 radio"
                            :class="
                              evalData && evalData.c_4.evalAns == 1
                                ? 'bg-green'
                                : ''
                            "
                            @click="evalData.c_4.evalAns = 1"
                          >
                            1
                          </div>
                        </td>
                        <td align="center" class="text-subtitle-1 pa-2">
                          <div
                            class="d-flex justify-center align-center border border-1 radio"
                            :class="
                              evalData && evalData.c_4.evalAns == 'NA'
                                ? 'bg-green'
                                : ''
                            "
                            @click="evalData.c_4.evalAns = 'NA'"
                          >
                            NA
                          </div>
                        </td>
                      </tr>
                      <tr>
                        <td class="px-1">
                          {{ evalData && evalData.c_5.question }}
                        </td>
                        <td align="center" class="text-subtitle-1 pa-2">
                          <div
                            class="d-flex justify-center align-center border border-1 radio"
                            :class="
                              evalData && evalData.c_5.evalAns == 5
                                ? 'bg-green'
                                : ''
                            "
                            @click="evalData.c_5.evalAns = 5"
                          >
                            5
                          </div>
                        </td>
                        <td align="center" class="text-subtitle-1 pa-2">
                          <div
                            class="d-flex justify-center align-center border border-1 radio"
                            :class="
                              evalData && evalData.c_5.evalAns == 4
                                ? 'bg-green'
                                : ''
                            "
                            @click="evalData.c_5.evalAns = 4"
                          >
                            4
                          </div>
                        </td>
                        <td align="center" class="text-subtitle-1 pa-2">
                          <div
                            class="d-flex justify-center align-center border border-1 radio"
                            :class="
                              evalData && evalData.c_5.evalAns == 3
                                ? 'bg-green'
                                : ''
                            "
                            @click="evalData.c_5.evalAns = 3"
                          >
                            3
                          </div>
                        </td>
                        <td align="center" class="text-subtitle-1 pa-2">
                          <div
                            class="d-flex justify-center align-center border border-1 radio"
                            :class="
                              evalData && evalData.c_5.evalAns == 2
                                ? 'bg-green'
                                : ''
                            "
                            @click="evalData.c_5.evalAns = 2"
                          >
                            2
                          </div>
                        </td>
                        <td align="center" class="text-subtitle-1 pa-2">
                          <div
                            class="d-flex justify-center align-center border border-1 radio"
                            :class="
                              evalData && evalData.c_5.evalAns == 1
                                ? 'bg-green'
                                : ''
                            "
                            @click="evalData.c_5.evalAns = 1"
                          >
                            1
                          </div>
                        </td>
                        <td align="center" class="text-subtitle-1 pa-2">
                          <div
                            class="d-flex justify-center align-center border border-1 radio"
                            :class="
                              evalData && evalData.c_5.evalAns == 'NA'
                                ? 'bg-green'
                                : ''
                            "
                            @click="evalData.c_5.evalAns = 'NA'"
                          >
                            NA
                          </div>
                        </td>
                      </tr>
                      <!-- C -->

                      <!-- D -->
                      <tr>
                        <td
                          colspan="7"
                          class="text-subtitle-1 font-weight-bold px-1"
                        >
                          D. TECHNICAL COMPETENCE AND TASK PERFORMANCE
                        </td>
                      </tr>
                      <tr>
                        <td class="px-1">
                          {{ evalData && evalData.d_1.question }}
                        </td>
                        <td align="center" class="text-subtitle-1 pa-2">
                          <div
                            class="d-flex justify-center align-center border border-1 radio"
                            :class="
                              evalData && evalData.d_1.evalAns == 5
                                ? 'bg-green'
                                : ''
                            "
                            @click="evalData.d_1.evalAns = 5"
                          >
                            5
                          </div>
                        </td>
                        <td align="center" class="text-subtitle-1 pa-2">
                          <div
                            class="d-flex justify-center align-center border border-1 radio"
                            :class="
                              evalData && evalData.d_1.evalAns == 4
                                ? 'bg-green'
                                : ''
                            "
                            @click="evalData.d_1.evalAns = 4"
                          >
                            4
                          </div>
                        </td>
                        <td align="center" class="text-subtitle-1 pa-2">
                          <div
                            class="d-flex justify-center align-center border border-1 radio"
                            :class="
                              evalData && evalData.d_1.evalAns == 3
                                ? 'bg-green'
                                : ''
                            "
                            @click="evalData.d_1.evalAns = 3"
                          >
                            3
                          </div>
                        </td>
                        <td align="center" class="text-subtitle-1 pa-2">
                          <div
                            class="d-flex justify-center align-center border border-1 radio"
                            :class="
                              evalData && evalData.d_1.evalAns == 2
                                ? 'bg-green'
                                : ''
                            "
                            @click="evalData.d_1.evalAns = 2"
                          >
                            2
                          </div>
                        </td>
                        <td align="center" class="text-subtitle-1 pa-2">
                          <div
                            class="d-flex justify-center align-center border border-1 radio"
                            :class="
                              evalData && evalData.d_1.evalAns == 1
                                ? 'bg-green'
                                : ''
                            "
                            @click="evalData.d_1.evalAns = 1"
                          >
                            1
                          </div>
                        </td>
                        <td align="center" class="text-subtitle-1 pa-2">
                          <div
                            class="d-flex justify-center align-center border border-1 radio"
                            :class="
                              evalData && evalData.d_1.evalAns == 'NA'
                                ? 'bg-green'
                                : ''
                            "
                            @click="evalData.d_1.evalAns = 'NA'"
                          >
                            NA
                          </div>
                        </td>
                      </tr>
                      <tr>
                        <td class="px-1">
                          {{ evalData && evalData.d_2.question }}
                        </td>
                        <td align="center" class="text-subtitle-1 pa-2">
                          <div
                            class="d-flex justify-center align-center border border-1 radio"
                            :class="
                              evalData && evalData.d_2.evalAns == 5
                                ? 'bg-green'
                                : ''
                            "
                            @click="evalData.d_2.evalAns = 5"
                          >
                            5
                          </div>
                        </td>
                        <td align="center" class="text-subtitle-1 pa-2">
                          <div
                            class="d-flex justify-center align-center border border-1 radio"
                            :class="
                              evalData && evalData.d_2.evalAns == 4
                                ? 'bg-green'
                                : ''
                            "
                            @click="evalData.d_2.evalAns = 4"
                          >
                            4
                          </div>
                        </td>
                        <td align="center" class="text-subtitle-1 pa-2">
                          <div
                            class="d-flex justify-center align-center border border-1 radio"
                            :class="
                              evalData && evalData.d_2.evalAns == 3
                                ? 'bg-green'
                                : ''
                            "
                            @click="evalData.d_2.evalAns = 3"
                          >
                            3
                          </div>
                        </td>
                        <td align="center" class="text-subtitle-1 pa-2">
                          <div
                            class="d-flex justify-center align-center border border-1 radio"
                            :class="
                              evalData && evalData.d_2.evalAns == 2
                                ? 'bg-green'
                                : ''
                            "
                            @click="evalData.d_2.evalAns = 2"
                          >
                            2
                          </div>
                        </td>
                        <td align="center" class="text-subtitle-1 pa-2">
                          <div
                            class="d-flex justify-center align-center border border-1 radio"
                            :class="
                              evalData && evalData.d_2.evalAns == 1
                                ? 'bg-green'
                                : ''
                            "
                            @click="evalData.d_2.evalAns = 1"
                          >
                            1
                          </div>
                        </td>
                        <td align="center" class="text-subtitle-1 pa-2">
                          <div
                            class="d-flex justify-center align-center border border-1 radio"
                            :class="
                              evalData && evalData.d_2.evalAns == 'NA'
                                ? 'bg-green'
                                : ''
                            "
                            @click="evalData.d_2.evalAns = 'NA'"
                          >
                            NA
                          </div>
                        </td>
                      </tr>
                      <tr>
                        <td class="px-1">
                          {{ evalData && evalData.d_3.question }}
                        </td>
                        <td align="center" class="text-subtitle-1 pa-2">
                          <div
                            class="d-flex justify-center align-center border border-1 radio"
                            :class="
                              evalData && evalData.d_3.evalAns == 5
                                ? 'bg-green'
                                : ''
                            "
                            @click="evalData.d_3.evalAns = 5"
                          >
                            5
                          </div>
                        </td>
                        <td align="center" class="text-subtitle-1 pa-2">
                          <div
                            class="d-flex justify-center align-center border border-1 radio"
                            :class="
                              evalData && evalData.d_3.evalAns == 4
                                ? 'bg-green'
                                : ''
                            "
                            @click="evalData.d_3.evalAns = 4"
                          >
                            4
                          </div>
                        </td>
                        <td align="center" class="text-subtitle-1 pa-2">
                          <div
                            class="d-flex justify-center align-center border border-1 radio"
                            :class="
                              evalData && evalData.d_3.evalAns == 3
                                ? 'bg-green'
                                : ''
                            "
                            @click="evalData.d_3.evalAns = 3"
                          >
                            3
                          </div>
                        </td>
                        <td align="center" class="text-subtitle-1 pa-2">
                          <div
                            class="d-flex justify-center align-center border border-1 radio"
                            :class="
                              evalData && evalData.d_3.evalAns == 2
                                ? 'bg-green'
                                : ''
                            "
                            @click="evalData.d_3.evalAns = 2"
                          >
                            2
                          </div>
                        </td>
                        <td align="center" class="text-subtitle-1 pa-2">
                          <div
                            class="d-flex justify-center align-center border border-1 radio"
                            :class="
                              evalData && evalData.d_3.evalAns == 1
                                ? 'bg-green'
                                : ''
                            "
                            @click="evalData.d_3.evalAns = 1"
                          >
                            1
                          </div>
                        </td>
                        <td align="center" class="text-subtitle-1 pa-2">
                          <div
                            class="d-flex justify-center align-center border border-1 radio"
                            :class="
                              evalData && evalData.d_3.evalAns == 'NA'
                                ? 'bg-green'
                                : ''
                            "
                            @click="evalData.d_3.evalAns = 'NA'"
                          >
                            NA
                          </div>
                        </td>
                      </tr>
                      <tr>
                        <td class="px-1">
                          {{ evalData && evalData.d_4.question }}
                        </td>
                        <td align="center" class="text-subtitle-1 pa-2">
                          <div
                            class="d-flex justify-center align-center border border-1 radio"
                            :class="
                              evalData && evalData.d_4.evalAns == 5
                                ? 'bg-green'
                                : ''
                            "
                            @click="evalData.d_4.evalAns = 5"
                          >
                            5
                          </div>
                        </td>
                        <td align="center" class="text-subtitle-1 pa-2">
                          <div
                            class="d-flex justify-center align-center border border-1 radio"
                            :class="
                              evalData && evalData.d_4.evalAns == 4
                                ? 'bg-green'
                                : ''
                            "
                            @click="evalData.d_4.evalAns = 4"
                          >
                            4
                          </div>
                        </td>
                        <td align="center" class="text-subtitle-1 pa-2">
                          <div
                            class="d-flex justify-center align-center border border-1 radio"
                            :class="
                              evalData && evalData.d_4.evalAns == 3
                                ? 'bg-green'
                                : ''
                            "
                            @click="evalData.d_4.evalAns = 3"
                          >
                            3
                          </div>
                        </td>
                        <td align="center" class="text-subtitle-1 pa-2">
                          <div
                            class="d-flex justify-center align-center border border-1 radio"
                            :class="
                              evalData && evalData.d_4.evalAns == 2
                                ? 'bg-green'
                                : ''
                            "
                            @click="evalData.d_4.evalAns = 2"
                          >
                            2
                          </div>
                        </td>
                        <td align="center" class="text-subtitle-1 pa-2">
                          <div
                            class="d-flex justify-center align-center border border-1 radio"
                            :class="
                              evalData && evalData.d_4.evalAns == 1
                                ? 'bg-green'
                                : ''
                            "
                            @click="evalData.d_4.evalAns = 1"
                          >
                            1
                          </div>
                        </td>
                        <td align="center" class="text-subtitle-1 pa-2">
                          <div
                            class="d-flex justify-center align-center border border-1 radio"
                            :class="
                              evalData && evalData.d_4.evalAns == 'NA'
                                ? 'bg-green'
                                : ''
                            "
                            @click="evalData.d_4.evalAns = 'NA'"
                          >
                            NA
                          </div>
                        </td>
                      </tr>
                      <tr>
                        <td class="px-1">
                          {{ evalData && evalData.d_5.question }}
                        </td>
                        <td align="center" class="text-subtitle-1 pa-2">
                          <div
                            class="d-flex justify-center align-center border border-1 radio"
                            :class="
                              evalData && evalData.d_5.evalAns == 5
                                ? 'bg-green'
                                : ''
                            "
                            @click="evalData.d_5.evalAns = 5"
                          >
                            5
                          </div>
                        </td>
                        <td align="center" class="text-subtitle-1 pa-2">
                          <div
                            class="d-flex justify-center align-center border border-1 radio"
                            :class="
                              evalData && evalData.d_5.evalAns == 4
                                ? 'bg-green'
                                : ''
                            "
                            @click="evalData.d_5.evalAns = 4"
                          >
                            4
                          </div>
                        </td>
                        <td align="center" class="text-subtitle-1 pa-2">
                          <div
                            class="d-flex justify-center align-center border border-1 radio"
                            :class="
                              evalData && evalData.d_5.evalAns == 3
                                ? 'bg-green'
                                : ''
                            "
                            @click="evalData.d_5.evalAns = 3"
                          >
                            3
                          </div>
                        </td>
                        <td align="center" class="text-subtitle-1 pa-2">
                          <div
                            class="d-flex justify-center align-center border border-1 radio"
                            :class="
                              evalData && evalData.d_5.evalAns == 2
                                ? 'bg-green'
                                : ''
                            "
                            @click="evalData.d_5.evalAns = 2"
                          >
                            2
                          </div>
                        </td>
                        <td align="center" class="text-subtitle-1 pa-2">
                          <div
                            class="d-flex justify-center align-center border border-1 radio"
                            :class="
                              evalData && evalData.d_5.evalAns == 1
                                ? 'bg-green'
                                : ''
                            "
                            @click="evalData.d_5.evalAns = 1"
                          >
                            1
                          </div>
                        </td>
                        <td align="center" class="text-subtitle-1 pa-2">
                          <div
                            class="d-flex justify-center align-center border border-1 radio"
                            :class="
                              evalData && evalData.d_5.evalAns == 'NA'
                                ? 'bg-green'
                                : ''
                            "
                            @click="evalData.d_5.evalAns = 'NA'"
                          >
                            NA
                          </div>
                        </td>
                      </tr>
                      <!-- D -->

                      <!-- E -->
                      <tr>
                        <td
                          colspan="7"
                          class="text-subtitle-1 font-weight-bold px-1"
                        >
                          E. BSIS-SPECIFIC TECHNICAL COMPETENCIES (Evaluate only
                          if applicable to the intern’s tasks)
                        </td>
                      </tr>
                      <tr>
                        <td class="px-1">
                          {{ evalData && evalData.e_1.question }}
                        </td>
                        <td align="center" class="text-subtitle-1 pa-2">
                          <div
                            class="d-flex justify-center align-center border border-1 radio"
                            :class="
                              evalData && evalData.e_1.evalAns == 5
                                ? 'bg-green'
                                : ''
                            "
                            @click="evalData.e_1.evalAns = 5"
                          >
                            5
                          </div>
                        </td>
                        <td align="center" class="text-subtitle-1 pa-2">
                          <div
                            class="d-flex justify-center align-center border border-1 radio"
                            :class="
                              evalData && evalData.e_1.evalAns == 4
                                ? 'bg-green'
                                : ''
                            "
                            @click="evalData.e_1.evalAns = 4"
                          >
                            4
                          </div>
                        </td>
                        <td align="center" class="text-subtitle-1 pa-2">
                          <div
                            class="d-flex justify-center align-center border border-1 radio"
                            :class="
                              evalData && evalData.e_1.evalAns == 3
                                ? 'bg-green'
                                : ''
                            "
                            @click="evalData.e_1.evalAns = 3"
                          >
                            3
                          </div>
                        </td>
                        <td align="center" class="text-subtitle-1 pa-2">
                          <div
                            class="d-flex justify-center align-center border border-1 radio"
                            :class="
                              evalData && evalData.e_1.evalAns == 2
                                ? 'bg-green'
                                : ''
                            "
                            @click="evalData.e_1.evalAns = 2"
                          >
                            2
                          </div>
                        </td>
                        <td align="center" class="text-subtitle-1 pa-2">
                          <div
                            class="d-flex justify-center align-center border border-1 radio"
                            :class="
                              evalData && evalData.e_1.evalAns == 1
                                ? 'bg-green'
                                : ''
                            "
                            @click="evalData.e_1.evalAns = 1"
                          >
                            1
                          </div>
                        </td>
                        <td align="center" class="text-subtitle-1 pa-2">
                          <div
                            class="d-flex justify-center align-center border border-1 radio"
                            :class="
                              evalData && evalData.e_1.evalAns == 'NA'
                                ? 'bg-green'
                                : ''
                            "
                            @click="evalData.e_1.evalAns = 'NA'"
                          >
                            NA
                          </div>
                        </td>
                      </tr>
                      <tr>
                        <td class="px-1">
                          {{ evalData && evalData.e_2.question }}
                        </td>
                        <td align="center" class="text-subtitle-1 pa-2">
                          <div
                            class="d-flex justify-center align-center border border-1 radio"
                            :class="
                              evalData && evalData.e_2.evalAns == 5
                                ? 'bg-green'
                                : ''
                            "
                            @click="evalData.e_2.evalAns = 5"
                          >
                            5
                          </div>
                        </td>
                        <td align="center" class="text-subtitle-1 pa-2">
                          <div
                            class="d-flex justify-center align-center border border-1 radio"
                            :class="
                              evalData && evalData.e_2.evalAns == 4
                                ? 'bg-green'
                                : ''
                            "
                            @click="evalData.e_2.evalAns = 4"
                          >
                            4
                          </div>
                        </td>
                        <td align="center" class="text-subtitle-1 pa-2">
                          <div
                            class="d-flex justify-center align-center border border-1 radio"
                            :class="
                              evalData && evalData.e_2.evalAns == 3
                                ? 'bg-green'
                                : ''
                            "
                            @click="evalData.e_2.evalAns = 3"
                          >
                            3
                          </div>
                        </td>
                        <td align="center" class="text-subtitle-1 pa-2">
                          <div
                            class="d-flex justify-center align-center border border-1 radio"
                            :class="
                              evalData && evalData.e_2.evalAns == 2
                                ? 'bg-green'
                                : ''
                            "
                            @click="evalData.e_2.evalAns = 2"
                          >
                            2
                          </div>
                        </td>
                        <td align="center" class="text-subtitle-1 pa-2">
                          <div
                            class="d-flex justify-center align-center border border-1 radio"
                            :class="
                              evalData && evalData.e_2.evalAns == 1
                                ? 'bg-green'
                                : ''
                            "
                            @click="evalData.e_2.evalAns = 1"
                          >
                            1
                          </div>
                        </td>
                        <td align="center" class="text-subtitle-1 pa-2">
                          <div
                            class="d-flex justify-center align-center border border-1 radio"
                            :class="
                              evalData && evalData.e_2.evalAns == 'NA'
                                ? 'bg-green'
                                : ''
                            "
                            @click="evalData.e_2.evalAns = 'NA'"
                          >
                            NA
                          </div>
                        </td>
                      </tr>
                      <tr>
                        <td class="px-1">
                          {{ evalData && evalData.e_3.question }}
                        </td>
                        <td align="center" class="text-subtitle-1 pa-2">
                          <div
                            class="d-flex justify-center align-center border border-1 radio"
                            :class="
                              evalData && evalData.e_3.evalAns == 5
                                ? 'bg-green'
                                : ''
                            "
                            @click="evalData.e_3.evalAns = 5"
                          >
                            5
                          </div>
                        </td>
                        <td align="center" class="text-subtitle-1 pa-2">
                          <div
                            class="d-flex justify-center align-center border border-1 radio"
                            :class="
                              evalData && evalData.e_3.evalAns == 4
                                ? 'bg-green'
                                : ''
                            "
                            @click="evalData.e_3.evalAns = 4"
                          >
                            4
                          </div>
                        </td>
                        <td align="center" class="text-subtitle-1 pa-2">
                          <div
                            class="d-flex justify-center align-center border border-1 radio"
                            :class="
                              evalData && evalData.e_3.evalAns == 3
                                ? 'bg-green'
                                : ''
                            "
                            @click="evalData.e_3.evalAns = 3"
                          >
                            3
                          </div>
                        </td>
                        <td align="center" class="text-subtitle-1 pa-2">
                          <div
                            class="d-flex justify-center align-center border border-1 radio"
                            :class="
                              evalData && evalData.e_3.evalAns == 2
                                ? 'bg-green'
                                : ''
                            "
                            @click="evalData.e_3.evalAns = 2"
                          >
                            2
                          </div>
                        </td>
                        <td align="center" class="text-subtitle-1 pa-2">
                          <div
                            class="d-flex justify-center align-center border border-1 radio"
                            :class="
                              evalData && evalData.e_3.evalAns == 1
                                ? 'bg-green'
                                : ''
                            "
                            @click="evalData.e_3.evalAns = 1"
                          >
                            1
                          </div>
                        </td>
                        <td align="center" class="text-subtitle-1 pa-2">
                          <div
                            class="d-flex justify-center align-center border border-1 radio"
                            :class="
                              evalData && evalData.e_3.evalAns == 'NA'
                                ? 'bg-green'
                                : ''
                            "
                            @click="evalData.e_3.evalAns = 'NA'"
                          >
                            NA
                          </div>
                        </td>
                      </tr>
                      <tr>
                        <td class="px-1">
                          {{ evalData && evalData.e_4.question }}
                        </td>
                        <td align="center" class="text-subtitle-1 pa-2">
                          <div
                            class="d-flex justify-center align-center border border-1 radio"
                            :class="
                              evalData && evalData.e_4.evalAns == 5
                                ? 'bg-green'
                                : ''
                            "
                            @click="evalData.e_4.evalAns = 5"
                          >
                            5
                          </div>
                        </td>
                        <td align="center" class="text-subtitle-1 pa-2">
                          <div
                            class="d-flex justify-center align-center border border-1 radio"
                            :class="
                              evalData && evalData.e_4.evalAns == 4
                                ? 'bg-green'
                                : ''
                            "
                            @click="evalData.e_4.evalAns = 4"
                          >
                            4
                          </div>
                        </td>
                        <td align="center" class="text-subtitle-1 pa-2">
                          <div
                            class="d-flex justify-center align-center border border-1 radio"
                            :class="
                              evalData && evalData.e_4.evalAns == 3
                                ? 'bg-green'
                                : ''
                            "
                            @click="evalData.e_4.evalAns = 3"
                          >
                            3
                          </div>
                        </td>
                        <td align="center" class="text-subtitle-1 pa-2">
                          <div
                            class="d-flex justify-center align-center border border-1 radio"
                            :class="
                              evalData && evalData.e_4.evalAns == 2
                                ? 'bg-green'
                                : ''
                            "
                            @click="evalData.e_4.evalAns = 2"
                          >
                            2
                          </div>
                        </td>
                        <td align="center" class="text-subtitle-1 pa-2">
                          <div
                            class="d-flex justify-center align-center border border-1 radio"
                            :class="
                              evalData && evalData.e_4.evalAns == 1
                                ? 'bg-green'
                                : ''
                            "
                            @click="evalData.e_4.evalAns = 1"
                          >
                            1
                          </div>
                        </td>
                        <td align="center" class="text-subtitle-1 pa-2">
                          <div
                            class="d-flex justify-center align-center border border-1 radio"
                            :class="
                              evalData && evalData.e_4.evalAns == 'NA'
                                ? 'bg-green'
                                : ''
                            "
                            @click="evalData.e_4.evalAns = 'NA'"
                          >
                            NA
                          </div>
                        </td>
                      </tr>
                      <tr>
                        <td class="px-1">
                          {{ evalData && evalData.e_5.question }}
                        </td>
                        <td align="center" class="text-subtitle-1 pa-2">
                          <div
                            class="d-flex justify-center align-center border border-1 radio"
                            :class="
                              evalData && evalData.e_5.evalAns == 5
                                ? 'bg-green'
                                : ''
                            "
                            @click="evalData.e_5.evalAns = 5"
                          >
                            5
                          </div>
                        </td>
                        <td align="center" class="text-subtitle-1 pa-2">
                          <div
                            class="d-flex justify-center align-center border border-1 radio"
                            :class="
                              evalData && evalData.e_5.evalAns == 4
                                ? 'bg-green'
                                : ''
                            "
                            @click="evalData.e_5.evalAns = 4"
                          >
                            4
                          </div>
                        </td>
                        <td align="center" class="text-subtitle-1 pa-2">
                          <div
                            class="d-flex justify-center align-center border border-1 radio"
                            :class="
                              evalData && evalData.e_5.evalAns == 3
                                ? 'bg-green'
                                : ''
                            "
                            @click="evalData.e_5.evalAns = 3"
                          >
                            3
                          </div>
                        </td>
                        <td align="center" class="text-subtitle-1 pa-2">
                          <div
                            class="d-flex justify-center align-center border border-1 radio"
                            :class="
                              evalData && evalData.e_5.evalAns == 2
                                ? 'bg-green'
                                : ''
                            "
                            @click="evalData.e_5.evalAns = 2"
                          >
                            2
                          </div>
                        </td>
                        <td align="center" class="text-subtitle-1 pa-2">
                          <div
                            class="d-flex justify-center align-center border border-1 radio"
                            :class="
                              evalData && evalData.e_5.evalAns == 1
                                ? 'bg-green'
                                : ''
                            "
                            @click="evalData.e_5.evalAns = 1"
                          >
                            1
                          </div>
                        </td>
                        <td align="center" class="text-subtitle-1 pa-2">
                          <div
                            class="d-flex justify-center align-center border border-1 radio"
                            :class="
                              evalData && evalData.e_5.evalAns == 'NA'
                                ? 'bg-green'
                                : ''
                            "
                            @click="evalData.e_5.evalAns = 'NA'"
                          >
                            NA
                          </div>
                        </td>
                      </tr>
                      <!-- E -->
                      <!-- F -->
                      <tr>
                        <td
                          colspan="7"
                          class="text-subtitle-1 font-weight-bold px-1"
                        >
                          F. BSIT-SPECIFIC TECHNICAL COMPETENCIES (Evaluate only
                          if applicable to the intern’s tasks)
                        </td>
                      </tr>
                      <tr>
                        <td class="px-1">
                          {{ evalData && evalData.f_1.question }}
                        </td>
                        <td align="center" class="text-subtitle-1 pa-2">
                          <div
                            class="d-flex justify-center align-center border border-1 radio"
                            :class="
                              evalData && evalData.f_1.evalAns == 5
                                ? 'bg-green'
                                : ''
                            "
                            @click="evalData.f_1.evalAns = 5"
                          >
                            5
                          </div>
                        </td>
                        <td align="center" class="text-subtitle-1 pa-2">
                          <div
                            class="d-flex justify-center align-center border border-1 radio"
                            :class="
                              evalData && evalData.f_1.evalAns == 4
                                ? 'bg-green'
                                : ''
                            "
                            @click="evalData.f_1.evalAns = 4"
                          >
                            4
                          </div>
                        </td>
                        <td align="center" class="text-subtitle-1 pa-2">
                          <div
                            class="d-flex justify-center align-center border border-1 radio"
                            :class="
                              evalData && evalData.f_1.evalAns == 3
                                ? 'bg-green'
                                : ''
                            "
                            @click="evalData.f_1.evalAns = 3"
                          >
                            3
                          </div>
                        </td>
                        <td align="center" class="text-subtitle-1 pa-2">
                          <div
                            class="d-flex justify-center align-center border border-1 radio"
                            :class="
                              evalData && evalData.f_1.evalAns == 2
                                ? 'bg-green'
                                : ''
                            "
                            @click="evalData.f_1.evalAns = 2"
                          >
                            2
                          </div>
                        </td>
                        <td align="center" class="text-subtitle-1 pa-2">
                          <div
                            class="d-flex justify-center align-center border border-1 radio"
                            :class="
                              evalData && evalData.f_1.evalAns == 1
                                ? 'bg-green'
                                : ''
                            "
                            @click="evalData.f_1.evalAns = 1"
                          >
                            1
                          </div>
                        </td>
                        <td align="center" class="text-subtitle-1 pa-2">
                          <div
                            class="d-flex justify-center align-center border border-1 radio"
                            :class="
                              evalData && evalData.f_1.evalAns == 'NA'
                                ? 'bg-green'
                                : ''
                            "
                            @click="evalData.f_1.evalAns = 'NA'"
                          >
                            NA
                          </div>
                        </td>
                      </tr>
                      <tr>
                        <td class="px-1">
                          {{ evalData && evalData.f_2.question }}
                        </td>
                        <td align="center" class="text-subtitle-1 pa-2">
                          <div
                            class="d-flex justify-center align-center border border-1 radio"
                            :class="
                              evalData && evalData.f_2.evalAns == 5
                                ? 'bg-green'
                                : ''
                            "
                            @click="evalData.f_2.evalAns = 5"
                          >
                            5
                          </div>
                        </td>
                        <td align="center" class="text-subtitle-1 pa-2">
                          <div
                            class="d-flex justify-center align-center border border-1 radio"
                            :class="
                              evalData && evalData.f_2.evalAns == 4
                                ? 'bg-green'
                                : ''
                            "
                            @click="evalData.f_2.evalAns = 4"
                          >
                            4
                          </div>
                        </td>
                        <td align="center" class="text-subtitle-1 pa-2">
                          <div
                            class="d-flex justify-center align-center border border-1 radio"
                            :class="
                              evalData && evalData.f_2.evalAns == 3
                                ? 'bg-green'
                                : ''
                            "
                            @click="evalData.f_2.evalAns = 3"
                          >
                            3
                          </div>
                        </td>
                        <td align="center" class="text-subtitle-1 pa-2">
                          <div
                            class="d-flex justify-center align-center border border-1 radio"
                            :class="
                              evalData && evalData.f_2.evalAns == 2
                                ? 'bg-green'
                                : ''
                            "
                            @click="evalData.f_2.evalAns = 2"
                          >
                            2
                          </div>
                        </td>
                        <td align="center" class="text-subtitle-1 pa-2">
                          <div
                            class="d-flex justify-center align-center border border-1 radio"
                            :class="
                              evalData && evalData.f_2.evalAns == 1
                                ? 'bg-green'
                                : ''
                            "
                            @click="evalData.f_2.evalAns = 1"
                          >
                            1
                          </div>
                        </td>
                        <td align="center" class="text-subtitle-1 pa-2">
                          <div
                            class="d-flex justify-center align-center border border-1 radio"
                            :class="
                              evalData && evalData.f_2.evalAns == 'NA'
                                ? 'bg-green'
                                : ''
                            "
                            @click="evalData.f_2.evalAns = 'NA'"
                          >
                            NA
                          </div>
                        </td>
                      </tr>
                      <tr>
                        <td class="px-1">
                          {{ evalData && evalData.f_3.question }}
                        </td>
                        <td align="center" class="text-subtitle-1 pa-2">
                          <div
                            class="d-flex justify-center align-center border border-1 radio"
                            :class="
                              evalData && evalData.f_3.evalAns == 5
                                ? 'bg-green'
                                : ''
                            "
                            @click="evalData.f_3.evalAns = 5"
                          >
                            5
                          </div>
                        </td>
                        <td align="center" class="text-subtitle-1 pa-2">
                          <div
                            class="d-flex justify-center align-center border border-1 radio"
                            :class="
                              evalData && evalData.f_3.evalAns == 4
                                ? 'bg-green'
                                : ''
                            "
                            @click="evalData.f_3.evalAns = 4"
                          >
                            4
                          </div>
                        </td>
                        <td align="center" class="text-subtitle-1 pa-2">
                          <div
                            class="d-flex justify-center align-center border border-1 radio"
                            :class="
                              evalData && evalData.f_3.evalAns == 3
                                ? 'bg-green'
                                : ''
                            "
                            @click="evalData.f_3.evalAns = 3"
                          >
                            3
                          </div>
                        </td>
                        <td align="center" class="text-subtitle-1 pa-2">
                          <div
                            class="d-flex justify-center align-center border border-1 radio"
                            :class="
                              evalData && evalData.f_3.evalAns == 2
                                ? 'bg-green'
                                : ''
                            "
                            @click="evalData.f_3.evalAns = 2"
                          >
                            2
                          </div>
                        </td>
                        <td align="center" class="text-subtitle-1 pa-2">
                          <div
                            class="d-flex justify-center align-center border border-1 radio"
                            :class="
                              evalData && evalData.f_3.evalAns == 1
                                ? 'bg-green'
                                : ''
                            "
                            @click="evalData.f_3.evalAns = 1"
                          >
                            1
                          </div>
                        </td>
                        <td align="center" class="text-subtitle-1 pa-2">
                          <div
                            class="d-flex justify-center align-center border border-1 radio"
                            :class="
                              evalData && evalData.f_3.evalAns == 'NA'
                                ? 'bg-green'
                                : ''
                            "
                            @click="evalData.f_3.evalAns = 'NA'"
                          >
                            NA
                          </div>
                        </td>
                      </tr>
                      <tr>
                        <td class="px-1">
                          {{ evalData && evalData.f_4.question }}
                        </td>
                        <td align="center" class="text-subtitle-1 pa-2">
                          <div
                            class="d-flex justify-center align-center border border-1 radio"
                            :class="
                              evalData && evalData.f_4.evalAns == 5
                                ? 'bg-green'
                                : ''
                            "
                            @click="evalData.f_4.evalAns = 5"
                          >
                            5
                          </div>
                        </td>
                        <td align="center" class="text-subtitle-1 pa-2">
                          <div
                            class="d-flex justify-center align-center border border-1 radio"
                            :class="
                              evalData && evalData.f_4.evalAns == 4
                                ? 'bg-green'
                                : ''
                            "
                            @click="evalData.f_4.evalAns = 4"
                          >
                            4
                          </div>
                        </td>
                        <td align="center" class="text-subtitle-1 pa-2">
                          <div
                            class="d-flex justify-center align-center border border-1 radio"
                            :class="
                              evalData && evalData.f_4.evalAns == 3
                                ? 'bg-green'
                                : ''
                            "
                            @click="evalData.f_4.evalAns = 3"
                          >
                            3
                          </div>
                        </td>
                        <td align="center" class="text-subtitle-1 pa-2">
                          <div
                            class="d-flex justify-center align-center border border-1 radio"
                            :class="
                              evalData && evalData.f_4.evalAns == 2
                                ? 'bg-green'
                                : ''
                            "
                            @click="evalData.f_4.evalAns = 2"
                          >
                            2
                          </div>
                        </td>
                        <td align="center" class="text-subtitle-1 pa-2">
                          <div
                            class="d-flex justify-center align-center border border-1 radio"
                            :class="
                              evalData && evalData.f_4.evalAns == 1
                                ? 'bg-green'
                                : ''
                            "
                            @click="evalData.f_4.evalAns = 1"
                          >
                            1
                          </div>
                        </td>
                        <td align="center" class="text-subtitle-1 pa-2">
                          <div
                            class="d-flex justify-center align-center border border-1 radio"
                            :class="
                              evalData && evalData.f_4.evalAns == 'NA'
                                ? 'bg-green'
                                : ''
                            "
                            @click="evalData.f_4.evalAns = 'NA'"
                          >
                            NA
                          </div>
                        </td>
                      </tr>
                      <tr>
                        <td class="px-1">
                          {{ evalData && evalData.f_5.question }}
                        </td>
                        <td align="center" class="text-subtitle-1 pa-2">
                          <div
                            class="d-flex justify-center align-center border border-1 radio"
                            :class="
                              evalData && evalData.f_5.evalAns == 5
                                ? 'bg-green'
                                : ''
                            "
                            @click="evalData.f_5.evalAns = 5"
                          >
                            5
                          </div>
                        </td>
                        <td align="center" class="text-subtitle-1 pa-2">
                          <div
                            class="d-flex justify-center align-center border border-1 radio"
                            :class="
                              evalData && evalData.f_5.evalAns == 4
                                ? 'bg-green'
                                : ''
                            "
                            @click="evalData.f_5.evalAns = 4"
                          >
                            4
                          </div>
                        </td>
                        <td align="center" class="text-subtitle-1 pa-2">
                          <div
                            class="d-flex justify-center align-center border border-1 radio"
                            :class="
                              evalData && evalData.f_5.evalAns == 3
                                ? 'bg-green'
                                : ''
                            "
                            @click="evalData.f_5.evalAns = 3"
                          >
                            3
                          </div>
                        </td>
                        <td align="center" class="text-subtitle-1 pa-2">
                          <div
                            class="d-flex justify-center align-center border border-1 radio"
                            :class="
                              evalData && evalData.f_5.evalAns == 2
                                ? 'bg-green'
                                : ''
                            "
                            @click="evalData.f_5.evalAns = 2"
                          >
                            2
                          </div>
                        </td>
                        <td align="center" class="text-subtitle-1 pa-2">
                          <div
                            class="d-flex justify-center align-center border border-1 radio"
                            :class="
                              evalData && evalData.f_5.evalAns == 1
                                ? 'bg-green'
                                : ''
                            "
                            @click="evalData.f_5.evalAns = 1"
                          >
                            1
                          </div>
                        </td>
                        <td align="center" class="text-subtitle-1 pa-2">
                          <div
                            class="d-flex justify-center align-center border border-1 radio"
                            :class="
                              evalData && evalData.f_5.evalAns == 'NA'
                                ? 'bg-green'
                                : ''
                            "
                            @click="evalData.f_5.evalAns = 'NA'"
                          >
                            NA
                          </div>
                        </td>
                      </tr>
                      <!-- F -->
                    </tbody>
                  </table>
                </v-col>
              </v-row>
            </v-container>
            <!-- BPA -->
            <v-container v-if="getProgramID == '5'">
              <v-row>
                <v-col cols="12">
                  <div class="rounded-lg pa-2 border border-1">
                    <div class="text-justify text-subtitle-1">
                      <p>
                        <b>Instruction:</b> Please evaluate the assigned
                        practicum student by indicating on the appropriate
                        column your rating. For every factor, encircle the
                        number using the following scale with their
                        corresponding descriptive ratings as follows:
                      </p>

                      <div class="text-subtitle-1 font-weight-bold mt-4">
                        Rating Legend:
                      </div>
                      <div class="">
                        <div class="d-flex ga-4">
                          <div class="text-subtitle-1 font-weight-bold">5</div>
                          <div class="text-subtitle-1 font-weight-bold">=</div>
                          <div class="text-subtitle-1">
                            <span class="font-weight-bold">Excellent</span>
                          </div>
                        </div>
                        <div class="d-flex ga-4">
                          <div class="text-subtitle-1 font-weight-bold">4</div>
                          <div class="text-subtitle-1 font-weight-bold">=</div>
                          <div class="text-subtitle-1">
                            <span class="font-weight-bold">Very Good</span>
                          </div>
                        </div>
                        <div class="d-flex ga-4">
                          <div class="text-subtitle-1 font-weight-bold">3</div>
                          <div class="text-subtitle-1 font-weight-bold">=</div>
                          <div class="text-subtitle-1">
                            <span class="font-weight-bold">Good</span>
                          </div>
                        </div>
                        <div class="d-flex ga-4">
                          <div class="text-subtitle-1 font-weight-bold">2</div>
                          <div class="text-subtitle-1 font-weight-bold">=</div>
                          <div class="text-subtitle-1">
                            <span class="font-weight-bold">Fair</span>
                          </div>
                        </div>
                        <div class="d-flex ga-4">
                          <div class="text-subtitle-1 font-weight-bold">1</div>
                          <div class="text-subtitle-1 font-weight-bold">=</div>
                          <div class="text-subtitle-1">
                            <span class="font-weight-bold">Poor</span>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </v-col>
                <v-col cols="12">
                  <div>
                    <div class="text-subtitle-1 font-weight-bold my-1">
                      I. PERFORMANCE FACTORS
                    </div>
                    <div>
                      <div>
                        <div>
                          <div
                            class="text-subtitle-1 font-weight-bold d-flex ga-2"
                          >
                            <div>1.</div>
                            <div class="font-weight-bold">Job Knowledge</div>
                          </div>
                          <div class="d-flex justify-space-between">
                            <div class="ml-5">
                              {{ evalData && evalData.a_1.question }}
                            </div>
                            <div class="d-flex ga-4">
                              <div
                                class="d-flex justify-center align-center border border-1 radio"
                                :class="
                                  evalData && evalData.a_1.evalAns == '5'
                                    ? 'bg-green'
                                    : ''
                                "
                                @click="evalData.a_1.evalAns = '5'"
                              >
                                5
                              </div>
                              <div
                                class="d-flex justify-center align-center border border-1 radio"
                                :class="
                                  evalData && evalData.a_1.evalAns == '4'
                                    ? 'bg-green'
                                    : ''
                                "
                                @click="evalData.a_1.evalAns = '4'"
                              >
                                4
                              </div>
                              <div
                                class="d-flex justify-center align-center border border-1 radio"
                                :class="
                                  evalData && evalData.a_1.evalAns == '3'
                                    ? 'bg-green'
                                    : ''
                                "
                                @click="evalData.a_1.evalAns = '3'"
                              >
                                3
                              </div>
                              <div
                                class="d-flex justify-center align-center border border-1 radio"
                                :class="
                                  evalData && evalData.a_1.evalAns == '2'
                                    ? 'bg-green'
                                    : ''
                                "
                                @click="evalData.a_1.evalAns = '2'"
                              >
                                2
                              </div>
                              <div
                                class="d-flex justify-center align-center border border-1 radio"
                                :class="
                                  evalData && evalData.a_1.evalAns == '1'
                                    ? 'bg-green'
                                    : ''
                                "
                                @click="evalData.a_1.evalAns = '1'"
                              >
                                1
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                      <div>
                        <div>
                          <div
                            class="text-subtitle-1 font-weight-bold d-flex ga-2"
                          >
                            <div>2</div>
                            <div class="font-weight-bold">Quality of Work</div>
                          </div>
                          <div class="d-flex justify-space-between">
                            <div class="ml-5">
                              {{ evalData && evalData.b_1.question }}
                            </div>
                            <div class="d-flex ga-4">
                              <div
                                class="d-flex justify-center align-center border border-1 radio"
                                :class="
                                  evalData && evalData.b_1.evalAns == '5'
                                    ? 'bg-green'
                                    : ''
                                "
                                @click="evalData.b_1.evalAns = '5'"
                              >
                                5
                              </div>
                              <div
                                class="d-flex justify-center align-center border border-1 radio"
                                :class="
                                  evalData && evalData.b_1.evalAns == '4'
                                    ? 'bg-green'
                                    : ''
                                "
                                @click="evalData.b_1.evalAns = '4'"
                              >
                                4
                              </div>
                              <div
                                class="d-flex justify-center align-center border border-1 radio"
                                :class="
                                  evalData && evalData.b_1.evalAns == '3'
                                    ? 'bg-green'
                                    : ''
                                "
                                @click="evalData.b_1.evalAns = '3'"
                              >
                                3
                              </div>
                              <div
                                class="d-flex justify-center align-center border border-1 radio"
                                :class="
                                  evalData && evalData.b_1.evalAns == '2'
                                    ? 'bg-green'
                                    : ''
                                "
                                @click="evalData.b_1.evalAns = '2'"
                              >
                                2
                              </div>
                              <div
                                class="d-flex justify-center align-center border border-1 radio"
                                :class="
                                  evalData && evalData.b_1.evalAns == '1'
                                    ? 'bg-green'
                                    : ''
                                "
                                @click="evalData.b_1.evalAns = '1'"
                              >
                                1
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                      <div>
                        <div>
                          <div
                            class="text-subtitle-1 font-weight-bold d-flex ga-2"
                          >
                            <div>3.</div>
                            <div class="font-weight-bold">Quantity of Work</div>
                          </div>
                          <div class="d-flex justify-space-between">
                            <div class="ml-5">
                              {{ evalData && evalData.c_1.question }}
                            </div>
                            <div class="d-flex ga-4">
                              <div
                                class="d-flex justify-center align-center border border-1 radio"
                                :class="
                                  evalData && evalData.c_1.evalAns == '5'
                                    ? 'bg-green'
                                    : ''
                                "
                                @click="evalData.c_1.evalAns = '5'"
                              >
                                5
                              </div>
                              <div
                                class="d-flex justify-center align-center border border-1 radio"
                                :class="
                                  evalData && evalData.c_1.evalAns == '4'
                                    ? 'bg-green'
                                    : ''
                                "
                                @click="evalData.c_1.evalAns = '4'"
                              >
                                4
                              </div>
                              <div
                                class="d-flex justify-center align-center border border-1 radio"
                                :class="
                                  evalData && evalData.c_1.evalAns == '3'
                                    ? 'bg-green'
                                    : ''
                                "
                                @click="evalData.c_1.evalAns = '3'"
                              >
                                3
                              </div>
                              <div
                                class="d-flex justify-center align-center border border-1 radio"
                                :class="
                                  evalData && evalData.c_1.evalAns == '2'
                                    ? 'bg-green'
                                    : ''
                                "
                                @click="evalData.c_1.evalAns = '2'"
                              >
                                2
                              </div>
                              <div
                                class="d-flex justify-center align-center border border-1 radio"
                                :class="
                                  evalData && evalData.c_1.evalAns == '1'
                                    ? 'bg-green'
                                    : ''
                                "
                                @click="evalData.c_1.evalAns = '1'"
                              >
                                1
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                      <div>
                        <div>
                          <div
                            class="text-subtitle-1 font-weight-bold d-flex ga-2"
                          >
                            <div>4.</div>
                            <div class="font-weight-bold">Dependability</div>
                          </div>
                          <div class="d-flex justify-space-between">
                            <div class="ml-5">
                              {{ evalData && evalData.d_1.question }}
                            </div>
                            <div class="d-flex ga-4">
                              <div
                                class="d-flex justify-center align-center border border-1 radio"
                                :class="
                                  evalData && evalData.d_1.evalAns == '5'
                                    ? 'bg-green'
                                    : ''
                                "
                                @click="evalData.d_1.evalAns = '5'"
                              >
                                5
                              </div>
                              <div
                                class="d-flex justify-center align-center border border-1 radio"
                                :class="
                                  evalData && evalData.d_1.evalAns == '4'
                                    ? 'bg-green'
                                    : ''
                                "
                                @click="evalData.d_1.evalAns = '4'"
                              >
                                4
                              </div>
                              <div
                                class="d-flex justify-center align-center border border-1 radio"
                                :class="
                                  evalData && evalData.d_1.evalAns == '3'
                                    ? 'bg-green'
                                    : ''
                                "
                                @click="evalData.d_1.evalAns = '3'"
                              >
                                3
                              </div>
                              <div
                                class="d-flex justify-center align-center border border-1 radio"
                                :class="
                                  evalData && evalData.d_1.evalAns == '2'
                                    ? 'bg-green'
                                    : ''
                                "
                                @click="evalData.d_1.evalAns = '2'"
                              >
                                2
                              </div>
                              <div
                                class="d-flex justify-center align-center border border-1 radio"
                                :class="
                                  evalData && evalData.d_1.evalAns == '1'
                                    ? 'bg-green'
                                    : ''
                                "
                                @click="evalData.d_1.evalAns = '1'"
                              >
                                1
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                      <div>
                        <div>
                          <div
                            class="text-subtitle-1 font-weight-bold d-flex ga-2"
                          >
                            <div>5.</div>
                            <div class="font-weight-bold">Creativity</div>
                          </div>
                          <div class="d-flex justify-space-between">
                            <div class="ml-5">
                              {{ evalData && evalData.e_1.question }}
                            </div>
                            <div class="d-flex ga-4">
                              <div
                                class="d-flex justify-center align-center border border-1 radio"
                                :class="
                                  evalData && evalData.e_1.evalAns == '5'
                                    ? 'bg-green'
                                    : ''
                                "
                                @click="evalData.e_1.evalAns = '5'"
                              >
                                5
                              </div>
                              <div
                                class="d-flex justify-center align-center border border-1 radio"
                                :class="
                                  evalData && evalData.e_1.evalAns == '4'
                                    ? 'bg-green'
                                    : ''
                                "
                                @click="evalData.e_1.evalAns = '4'"
                              >
                                4
                              </div>
                              <div
                                class="d-flex justify-center align-center border border-1 radio"
                                :class="
                                  evalData && evalData.e_1.evalAns == '3'
                                    ? 'bg-green'
                                    : ''
                                "
                                @click="evalData.e_1.evalAns = '3'"
                              >
                                3
                              </div>
                              <div
                                class="d-flex justify-center align-center border border-1 radio"
                                :class="
                                  evalData && evalData.e_1.evalAns == '2'
                                    ? 'bg-green'
                                    : ''
                                "
                                @click="evalData.e_1.evalAns = '2'"
                              >
                                2
                              </div>
                              <div
                                class="d-flex justify-center align-center border border-1 radio"
                                :class="
                                  evalData && evalData.e_1.evalAns == '1'
                                    ? 'bg-green'
                                    : ''
                                "
                                @click="evalData.e_1.evalAns = '1'"
                              >
                                1
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                      <div>
                        <div>
                          <div
                            class="text-subtitle-1 font-weight-bold d-flex ga-2"
                          >
                            <div>6.</div>
                            <div class="font-weight-bold">Organization</div>
                          </div>
                          <div class="d-flex justify-space-between">
                            <div class="ml-5">
                              {{ evalData && evalData.f_1.question }}
                            </div>
                            <div class="d-flex ga-4">
                              <div
                                class="d-flex justify-center align-center border border-1 radio"
                                :class="
                                  evalData && evalData.f_1.evalAns == '5'
                                    ? 'bg-green'
                                    : ''
                                "
                                @click="evalData.f_1.evalAns = '5'"
                              >
                                5
                              </div>
                              <div
                                class="d-flex justify-center align-center border border-1 radio"
                                :class="
                                  evalData && evalData.f_1.evalAns == '4'
                                    ? 'bg-green'
                                    : ''
                                "
                                @click="evalData.f_1.evalAns = '4'"
                              >
                                4
                              </div>
                              <div
                                class="d-flex justify-center align-center border border-1 radio"
                                :class="
                                  evalData && evalData.f_1.evalAns == '3'
                                    ? 'bg-green'
                                    : ''
                                "
                                @click="evalData.f_1.evalAns = '3'"
                              >
                                3
                              </div>
                              <div
                                class="d-flex justify-center align-center border border-1 radio"
                                :class="
                                  evalData && evalData.f_1.evalAns == '2'
                                    ? 'bg-green'
                                    : ''
                                "
                                @click="evalData.f_1.evalAns = '2'"
                              >
                                2
                              </div>
                              <div
                                class="d-flex justify-center align-center border border-1 radio"
                                :class="
                                  evalData && evalData.f_1.evalAns == '1'
                                    ? 'bg-green'
                                    : ''
                                "
                                @click="evalData.f_1.evalAns = '1'"
                              >
                                1
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                      <div>
                        <div>
                          <div
                            class="text-subtitle-1 font-weight-bold d-flex ga-2"
                          >
                            <div>7.</div>
                            <div class="font-weight-bold">Initiative</div>
                          </div>
                          <div class="d-flex justify-space-between">
                            <div class="ml-5">
                              {{ evalData && evalData.g_1.question }}
                            </div>
                            <div class="d-flex ga-4">
                              <div
                                class="d-flex justify-center align-center border border-1 radio"
                                :class="
                                  evalData && evalData.g_1.evalAns == '5'
                                    ? 'bg-green'
                                    : ''
                                "
                                @click="evalData.g_1.evalAns = '5'"
                              >
                                5
                              </div>
                              <div
                                class="d-flex justify-center align-center border border-1 radio"
                                :class="
                                  evalData && evalData.g_1.evalAns == '4'
                                    ? 'bg-green'
                                    : ''
                                "
                                @click="evalData.g_1.evalAns = '4'"
                              >
                                4
                              </div>
                              <div
                                class="d-flex justify-center align-center border border-1 radio"
                                :class="
                                  evalData && evalData.g_1.evalAns == '3'
                                    ? 'bg-green'
                                    : ''
                                "
                                @click="evalData.g_1.evalAns = '3'"
                              >
                                3
                              </div>
                              <div
                                class="d-flex justify-center align-center border border-1 radio"
                                :class="
                                  evalData && evalData.g_1.evalAns == '2'
                                    ? 'bg-green'
                                    : ''
                                "
                                @click="evalData.g_1.evalAns = '2'"
                              >
                                2
                              </div>
                              <div
                                class="d-flex justify-center align-center border border-1 radio"
                                :class="
                                  evalData && evalData.g_1.evalAns == '1'
                                    ? 'bg-green'
                                    : ''
                                "
                                @click="evalData.g_1.evalAns = '1'"
                              >
                                1
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                      <div>
                        <div>
                          <div
                            class="text-subtitle-1 font-weight-bold d-flex ga-2"
                          >
                            <div>8.</div>
                            <div class="font-weight-bold">Industry</div>
                          </div>
                          <div class="d-flex justify-space-between">
                            <div class="ml-5">
                              {{ evalData && evalData.h_1.question }}
                            </div>
                            <div class="d-flex ga-4">
                              <div
                                class="d-flex justify-center align-center border border-1 radio"
                                :class="
                                  evalData && evalData.h_1.evalAns == '5'
                                    ? 'bg-green'
                                    : ''
                                "
                                @click="evalData.h_1.evalAns = '5'"
                              >
                                5
                              </div>
                              <div
                                class="d-flex justify-center align-center border border-1 radio"
                                :class="
                                  evalData && evalData.h_1.evalAns == '4'
                                    ? 'bg-green'
                                    : ''
                                "
                                @click="evalData.h_1.evalAns = '4'"
                              >
                                4
                              </div>
                              <div
                                class="d-flex justify-center align-center border border-1 radio"
                                :class="
                                  evalData && evalData.h_1.evalAns == '3'
                                    ? 'bg-green'
                                    : ''
                                "
                                @click="evalData.h_1.evalAns = '3'"
                              >
                                3
                              </div>
                              <div
                                class="d-flex justify-center align-center border border-1 radio"
                                :class="
                                  evalData && evalData.h_1.evalAns == '2'
                                    ? 'bg-green'
                                    : ''
                                "
                                @click="evalData.h_1.evalAns = '2'"
                              >
                                2
                              </div>
                              <div
                                class="d-flex justify-center align-center border border-1 radio"
                                :class="
                                  evalData && evalData.h_1.evalAns == '1'
                                    ? 'bg-green'
                                    : ''
                                "
                                @click="evalData.h_1.evalAns = '1'"
                              >
                                1
                              </div>
                            </div>
                          </div>
                          <div class="d-flex justify-space-between">
                            <div class="ml-5">
                              {{ evalData && evalData.h_2.question }}
                            </div>
                            <div class="d-flex ga-4">
                              <div
                                class="d-flex justify-center align-center border border-1 radio"
                                :class="
                                  evalData && evalData.h_2.evalAns == '5'
                                    ? 'bg-green'
                                    : ''
                                "
                                @click="evalData.h_2.evalAns = '5'"
                              >
                                5
                              </div>
                              <div
                                class="d-flex justify-center align-center border border-1 radio"
                                :class="
                                  evalData && evalData.h_2.evalAns == '4'
                                    ? 'bg-green'
                                    : ''
                                "
                                @click="evalData.h_2.evalAns = '4'"
                              >
                                4
                              </div>
                              <div
                                class="d-flex justify-center align-center border border-1 radio"
                                :class="
                                  evalData && evalData.h_2.evalAns == '3'
                                    ? 'bg-green'
                                    : ''
                                "
                                @click="evalData.h_2.evalAns = '3'"
                              >
                                3
                              </div>
                              <div
                                class="d-flex justify-center align-center border border-1 radio"
                                :class="
                                  evalData && evalData.h_2.evalAns == '2'
                                    ? 'bg-green'
                                    : ''
                                "
                                @click="evalData.h_2.evalAns = '2'"
                              >
                                2
                              </div>
                              <div
                                class="d-flex justify-center align-center border border-1 radio"
                                :class="
                                  evalData && evalData.h_2.evalAns == '1'
                                    ? 'bg-green'
                                    : ''
                                "
                                @click="evalData.h_2.evalAns = '1'"
                              >
                                1
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div>
                    <div class="text-subtitle-1 font-weight-bold my-1">
                      II. PERSONAL QUALITIES AND MOTIVATION
                    </div>
                    <div>
                      <div>
                        <div>
                          <div
                            class="text-subtitle-1 font-weight-bold d-flex ga-2"
                          >
                            <div>9.</div>
                            <div class="font-weight-bold">
                              Attitude Toward the Job
                            </div>
                          </div>
                          <div class="d-flex justify-space-between">
                            <div class="ml-5">
                              {{ evalData && evalData.i_1.question }}
                            </div>
                            <div class="d-flex ga-4">
                              <div
                                class="d-flex justify-center align-center border border-1 radio"
                                :class="
                                  evalData && evalData.i_1.evalAns == '5'
                                    ? 'bg-green'
                                    : ''
                                "
                                @click="evalData.i_1.evalAns = '5'"
                              >
                                5
                              </div>
                              <div
                                class="d-flex justify-center align-center border border-1 radio"
                                :class="
                                  evalData && evalData.i_1.evalAns == '4'
                                    ? 'bg-green'
                                    : ''
                                "
                                @click="evalData.i_1.evalAns = '4'"
                              >
                                4
                              </div>
                              <div
                                class="d-flex justify-center align-center border border-1 radio"
                                :class="
                                  evalData && evalData.i_1.evalAns == '3'
                                    ? 'bg-green'
                                    : ''
                                "
                                @click="evalData.i_1.evalAns = '3'"
                              >
                                3
                              </div>
                              <div
                                class="d-flex justify-center align-center border border-1 radio"
                                :class="
                                  evalData && evalData.i_1.evalAns == '2'
                                    ? 'bg-green'
                                    : ''
                                "
                                @click="evalData.i_1.evalAns = '2'"
                              >
                                2
                              </div>
                              <div
                                class="d-flex justify-center align-center border border-1 radio"
                                :class="
                                  evalData && evalData.i_1.evalAns == '1'
                                    ? 'bg-green'
                                    : ''
                                "
                                @click="evalData.i_1.evalAns = '1'"
                              >
                                1
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                      <div>
                        <div>
                          <div
                            class="text-subtitle-1 font-weight-bold d-flex ga-2"
                          >
                            <div>10.</div>
                            <div class="font-weight-bold">
                              Attitude Toward the Work
                            </div>
                          </div>
                          <div class="d-flex justify-space-between">
                            <div class="ml-5">
                              {{ evalData && evalData.j_1.question }}
                            </div>
                            <div class="d-flex ga-4">
                              <div
                                class="d-flex justify-center align-center border border-1 radio"
                                :class="
                                  evalData && evalData.j_1.evalAns == '5'
                                    ? 'bg-green'
                                    : ''
                                "
                                @click="evalData.j_1.evalAns = '5'"
                              >
                                5
                              </div>
                              <div
                                class="d-flex justify-center align-center border border-1 radio"
                                :class="
                                  evalData && evalData.j_1.evalAns == '4'
                                    ? 'bg-green'
                                    : ''
                                "
                                @click="evalData.j_1.evalAns = '4'"
                              >
                                4
                              </div>
                              <div
                                class="d-flex justify-center align-center border border-1 radio"
                                :class="
                                  evalData && evalData.j_1.evalAns == '3'
                                    ? 'bg-green'
                                    : ''
                                "
                                @click="evalData.j_1.evalAns = '3'"
                              >
                                3
                              </div>
                              <div
                                class="d-flex justify-center align-center border border-1 radio"
                                :class="
                                  evalData && evalData.j_1.evalAns == '2'
                                    ? 'bg-green'
                                    : ''
                                "
                                @click="evalData.j_1.evalAns = '2'"
                              >
                                2
                              </div>
                              <div
                                class="d-flex justify-center align-center border border-1 radio"
                                :class="
                                  evalData && evalData.j_1.evalAns == '1'
                                    ? 'bg-green'
                                    : ''
                                "
                                @click="evalData.j_1.evalAns = '1'"
                              >
                                1
                              </div>
                            </div>
                          </div>
                          <div class="d-flex justify-space-between">
                            <div class="ml-5">
                              {{ evalData && evalData.j_2.question }}
                            </div>
                            <div class="d-flex ga-4">
                              <div
                                class="d-flex justify-center align-center border border-1 radio"
                                :class="
                                  evalData && evalData.j_2.evalAns == '5'
                                    ? 'bg-green'
                                    : ''
                                "
                                @click="evalData.j_2.evalAns = '5'"
                              >
                                5
                              </div>
                              <div
                                class="d-flex justify-center align-center border border-1 radio"
                                :class="
                                  evalData && evalData.j_2.evalAns == '4'
                                    ? 'bg-green'
                                    : ''
                                "
                                @click="evalData.j_2.evalAns = '4'"
                              >
                                4
                              </div>
                              <div
                                class="d-flex justify-center align-center border border-1 radio"
                                :class="
                                  evalData && evalData.j_2.evalAns == '3'
                                    ? 'bg-green'
                                    : ''
                                "
                                @click="evalData.j_2.evalAns = '3'"
                              >
                                3
                              </div>
                              <div
                                class="d-flex justify-center align-center border border-1 radio"
                                :class="
                                  evalData && evalData.j_2.evalAns == '2'
                                    ? 'bg-green'
                                    : ''
                                "
                                @click="evalData.j_2.evalAns = '2'"
                              >
                                2
                              </div>
                              <div
                                class="d-flex justify-center align-center border border-1 radio"
                                :class="
                                  evalData && evalData.j_2.evalAns == '1'
                                    ? 'bg-green'
                                    : ''
                                "
                                @click="evalData.j_2.evalAns = '1'"
                              >
                                1
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                      <div>
                        <div>
                          <div
                            class="text-subtitle-1 font-weight-bold d-flex ga-2"
                          >
                            <div>11.</div>
                            <div class="font-weight-bold">Cooperation</div>
                          </div>
                          <div class="d-flex justify-space-between">
                            <div class="ml-5">
                              {{ evalData && evalData.k_1.question }}
                            </div>
                            <div class="d-flex ga-4">
                              <div
                                class="d-flex justify-center align-center border border-1 radio"
                                :class="
                                  evalData && evalData.k_1.evalAns == '5'
                                    ? 'bg-green'
                                    : ''
                                "
                                @click="evalData.k_1.evalAns = '5'"
                              >
                                5
                              </div>
                              <div
                                class="d-flex justify-center align-center border border-1 radio"
                                :class="
                                  evalData && evalData.k_1.evalAns == '4'
                                    ? 'bg-green'
                                    : ''
                                "
                                @click="evalData.k_1.evalAns = '4'"
                              >
                                4
                              </div>
                              <div
                                class="d-flex justify-center align-center border border-1 radio"
                                :class="
                                  evalData && evalData.k_1.evalAns == '3'
                                    ? 'bg-green'
                                    : ''
                                "
                                @click="evalData.k_1.evalAns = '3'"
                              >
                                3
                              </div>
                              <div
                                class="d-flex justify-center align-center border border-1 radio"
                                :class="
                                  evalData && evalData.k_1.evalAns == '2'
                                    ? 'bg-green'
                                    : ''
                                "
                                @click="evalData.k_1.evalAns = '2'"
                              >
                                2
                              </div>
                              <div
                                class="d-flex justify-center align-center border border-1 radio"
                                :class="
                                  evalData && evalData.k_1.evalAns == '1'
                                    ? 'bg-green'
                                    : ''
                                "
                                @click="evalData.k_1.evalAns = '1'"
                              >
                                1
                              </div>
                            </div>
                          </div>
                          <div class="d-flex justify-space-between">
                            <div class="ml-5">
                              {{ evalData && evalData.k_2.question }}
                            </div>
                            <div class="d-flex ga-4">
                              <div
                                class="d-flex justify-center align-center border border-1 radio"
                                :class="
                                  evalData && evalData.k_2.evalAns == '5'
                                    ? 'bg-green'
                                    : ''
                                "
                                @click="evalData.k_2.evalAns = '5'"
                              >
                                5
                              </div>
                              <div
                                class="d-flex justify-center align-center border border-1 radio"
                                :class="
                                  evalData && evalData.k_2.evalAns == '4'
                                    ? 'bg-green'
                                    : ''
                                "
                                @click="evalData.k_2.evalAns = '4'"
                              >
                                4
                              </div>
                              <div
                                class="d-flex justify-center align-center border border-1 radio"
                                :class="
                                  evalData && evalData.k_2.evalAns == '3'
                                    ? 'bg-green'
                                    : ''
                                "
                                @click="evalData.k_2.evalAns = '3'"
                              >
                                3
                              </div>
                              <div
                                class="d-flex justify-center align-center border border-1 radio"
                                :class="
                                  evalData && evalData.k_2.evalAns == '2'
                                    ? 'bg-green'
                                    : ''
                                "
                                @click="evalData.k_2.evalAns = '2'"
                              >
                                2
                              </div>
                              <div
                                class="d-flex justify-center align-center border border-1 radio"
                                :class="
                                  evalData && evalData.k_2.evalAns == '1'
                                    ? 'bg-green'
                                    : ''
                                "
                                @click="evalData.k_2.evalAns = '1'"
                              >
                                1
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                      <div>
                        <div>
                          <div
                            class="text-subtitle-1 font-weight-bold d-flex ga-2"
                          >
                            <div>12.</div>
                            <div class="font-weight-bold">Personality</div>
                          </div>
                          <div class="d-flex justify-space-between">
                            <div class="ml-5">
                              {{ evalData && evalData.l_1.question }}
                            </div>
                            <div class="d-flex ga-4">
                              <div
                                class="d-flex justify-center align-center border border-1 radio"
                                :class="
                                  evalData && evalData.l_1.evalAns == '5'
                                    ? 'bg-green'
                                    : ''
                                "
                                @click="evalData.l_1.evalAns = '5'"
                              >
                                5
                              </div>
                              <div
                                class="d-flex justify-center align-center border border-1 radio"
                                :class="
                                  evalData && evalData.l_1.evalAns == '4'
                                    ? 'bg-green'
                                    : ''
                                "
                                @click="evalData.l_1.evalAns = '4'"
                              >
                                4
                              </div>
                              <div
                                class="d-flex justify-center align-center border border-1 radio"
                                :class="
                                  evalData && evalData.l_1.evalAns == '3'
                                    ? 'bg-green'
                                    : ''
                                "
                                @click="evalData.l_1.evalAns = '3'"
                              >
                                3
                              </div>
                              <div
                                class="d-flex justify-center align-center border border-1 radio"
                                :class="
                                  evalData && evalData.l_1.evalAns == '2'
                                    ? 'bg-green'
                                    : ''
                                "
                                @click="evalData.l_1.evalAns = '2'"
                              >
                                2
                              </div>
                              <div
                                class="d-flex justify-center align-center border border-1 radio"
                                :class="
                                  evalData && evalData.l_1.evalAns == '1'
                                    ? 'bg-green'
                                    : ''
                                "
                                @click="evalData.l_1.evalAns = '1'"
                              >
                                1
                              </div>
                            </div>
                          </div>
                          <div class="d-flex justify-space-between">
                            <div class="ml-5">
                              {{ evalData && evalData.l_2.question }}
                            </div>
                            <div class="d-flex ga-4">
                              <div
                                class="d-flex justify-center align-center border border-1 radio"
                                :class="
                                  evalData && evalData.l_2.evalAns == '5'
                                    ? 'bg-green'
                                    : ''
                                "
                                @click="evalData.l_2.evalAns = '5'"
                              >
                                5
                              </div>
                              <div
                                class="d-flex justify-center align-center border border-1 radio"
                                :class="
                                  evalData && evalData.l_2.evalAns == '4'
                                    ? 'bg-green'
                                    : ''
                                "
                                @click="evalData.l_2.evalAns = '4'"
                              >
                                4
                              </div>
                              <div
                                class="d-flex justify-center align-center border border-1 radio"
                                :class="
                                  evalData && evalData.l_2.evalAns == '3'
                                    ? 'bg-green'
                                    : ''
                                "
                                @click="evalData.l_2.evalAns = '3'"
                              >
                                3
                              </div>
                              <div
                                class="d-flex justify-center align-center border border-1 radio"
                                :class="
                                  evalData && evalData.l_2.evalAns == '2'
                                    ? 'bg-green'
                                    : ''
                                "
                                @click="evalData.l_2.evalAns = '2'"
                              >
                                2
                              </div>
                              <div
                                class="d-flex justify-center align-center border border-1 radio"
                                :class="
                                  evalData && evalData.l_2.evalAns == '1'
                                    ? 'bg-green'
                                    : ''
                                "
                                @click="evalData.l_2.evalAns = '1'"
                              >
                                1
                              </div>
                            </div>
                          </div>
                          <div class="d-flex justify-space-between">
                            <div class="ml-5">
                              {{ evalData && evalData.l_3.question }}
                            </div>
                            <div class="d-flex ga-4">
                              <div
                                class="d-flex justify-center align-center border border-1 radio"
                                :class="
                                  evalData && evalData.l_3.evalAns == '5'
                                    ? 'bg-green'
                                    : ''
                                "
                                @click="evalData.l_3.evalAns = '5'"
                              >
                                5
                              </div>
                              <div
                                class="d-flex justify-center align-center border border-1 radio"
                                :class="
                                  evalData && evalData.l_3.evalAns == '4'
                                    ? 'bg-green'
                                    : ''
                                "
                                @click="evalData.l_3.evalAns = '4'"
                              >
                                4
                              </div>
                              <div
                                class="d-flex justify-center align-center border border-1 radio"
                                :class="
                                  evalData && evalData.l_3.evalAns == '3'
                                    ? 'bg-green'
                                    : ''
                                "
                                @click="evalData.l_3.evalAns = '3'"
                              >
                                3
                              </div>
                              <div
                                class="d-flex justify-center align-center border border-1 radio"
                                :class="
                                  evalData && evalData.l_3.evalAns == '2'
                                    ? 'bg-green'
                                    : ''
                                "
                                @click="evalData.l_3.evalAns = '2'"
                              >
                                2
                              </div>
                              <div
                                class="d-flex justify-center align-center border border-1 radio"
                                :class="
                                  evalData && evalData.l_3.evalAns == '1'
                                    ? 'bg-green'
                                    : ''
                                "
                                @click="evalData.l_3.evalAns = '1'"
                              >
                                1
                              </div>
                            </div>
                          </div>
                          <div class="d-flex justify-space-between">
                            <div class="ml-5">
                              {{ evalData && evalData.l_4.question }}
                            </div>
                            <div class="d-flex ga-4">
                              <div
                                class="d-flex justify-center align-center border border-1 radio"
                                :class="
                                  evalData && evalData.l_4.evalAns == '5'
                                    ? 'bg-green'
                                    : ''
                                "
                                @click="evalData.l_4.evalAns = '5'"
                              >
                                5
                              </div>
                              <div
                                class="d-flex justify-center align-center border border-1 radio"
                                :class="
                                  evalData && evalData.l_4.evalAns == '4'
                                    ? 'bg-green'
                                    : ''
                                "
                                @click="evalData.l_4.evalAns = '4'"
                              >
                                4
                              </div>
                              <div
                                class="d-flex justify-center align-center border border-1 radio"
                                :class="
                                  evalData && evalData.l_4.evalAns == '3'
                                    ? 'bg-green'
                                    : ''
                                "
                                @click="evalData.l_4.evalAns = '3'"
                              >
                                3
                              </div>
                              <div
                                class="d-flex justify-center align-center border border-1 radio"
                                :class="
                                  evalData && evalData.l_4.evalAns == '2'
                                    ? 'bg-green'
                                    : ''
                                "
                                @click="evalData.l_4.evalAns = '2'"
                              >
                                2
                              </div>
                              <div
                                class="d-flex justify-center align-center border border-1 radio"
                                :class="
                                  evalData && evalData.l_4.evalAns == '1'
                                    ? 'bg-green'
                                    : ''
                                "
                                @click="evalData.l_4.evalAns = '1'"
                              >
                                1
                              </div>
                            </div>
                          </div>
                          <div class="d-flex justify-space-between">
                            <div class="ml-5">
                              {{ evalData && evalData.l_5.question }}
                            </div>
                            <div class="d-flex ga-4">
                              <div
                                class="d-flex justify-center align-center border border-1 radio"
                                :class="
                                  evalData && evalData.l_5.evalAns == '5'
                                    ? 'bg-green'
                                    : ''
                                "
                                @click="evalData.l_5.evalAns = '5'"
                              >
                                5
                              </div>
                              <div
                                class="d-flex justify-center align-center border border-1 radio"
                                :class="
                                  evalData && evalData.l_5.evalAns == '4'
                                    ? 'bg-green'
                                    : ''
                                "
                                @click="evalData.l_5.evalAns = '4'"
                              >
                                4
                              </div>
                              <div
                                class="d-flex justify-center align-center border border-1 radio"
                                :class="
                                  evalData && evalData.l_5.evalAns == '3'
                                    ? 'bg-green'
                                    : ''
                                "
                                @click="evalData.l_5.evalAns = '3'"
                              >
                                3
                              </div>
                              <div
                                class="d-flex justify-center align-center border border-1 radio"
                                :class="
                                  evalData && evalData.l_5.evalAns == '2'
                                    ? 'bg-green'
                                    : ''
                                "
                                @click="evalData.l_5.evalAns = '2'"
                              >
                                2
                              </div>
                              <div
                                class="d-flex justify-center align-center border border-1 radio"
                                :class="
                                  evalData && evalData.l_5.evalAns == '1'
                                    ? 'bg-green'
                                    : ''
                                "
                                @click="evalData.l_5.evalAns = '1'"
                              >
                                1
                              </div>
                            </div>
                          </div>
                          <div class="d-flex justify-space-between">
                            <div class="ml-5">
                              {{ evalData && evalData.l_6.question }}
                            </div>
                            <div class="d-flex ga-4">
                              <div
                                class="d-flex justify-center align-center border border-1 radio"
                                :class="
                                  evalData && evalData.l_6.evalAns == '5'
                                    ? 'bg-green'
                                    : ''
                                "
                                @click="evalData.l_6.evalAns = '5'"
                              >
                                5
                              </div>
                              <div
                                class="d-flex justify-center align-center border border-1 radio"
                                :class="
                                  evalData && evalData.l_6.evalAns == '4'
                                    ? 'bg-green'
                                    : ''
                                "
                                @click="evalData.l_6.evalAns = '4'"
                              >
                                4
                              </div>
                              <div
                                class="d-flex justify-center align-center border border-1 radio"
                                :class="
                                  evalData && evalData.l_6.evalAns == '3'
                                    ? 'bg-green'
                                    : ''
                                "
                                @click="evalData.l_6.evalAns = '3'"
                              >
                                3
                              </div>
                              <div
                                class="d-flex justify-center align-center border border-1 radio"
                                :class="
                                  evalData && evalData.l_6.evalAns == '2'
                                    ? 'bg-green'
                                    : ''
                                "
                                @click="evalData.l_6.evalAns = '2'"
                              >
                                2
                              </div>
                              <div
                                class="d-flex justify-center align-center border border-1 radio"
                                :class="
                                  evalData && evalData.l_6.evalAns == '1'
                                    ? 'bg-green'
                                    : ''
                                "
                                @click="evalData.l_6.evalAns = '1'"
                              >
                                1
                              </div>
                            </div>
                          </div>
                          <div class="d-flex justify-space-between">
                            <div class="ml-5">
                              {{ evalData && evalData.l_7.question }}
                            </div>
                            <div class="d-flex ga-4">
                              <div
                                class="d-flex justify-center align-center border border-1 radio"
                                :class="
                                  evalData && evalData.l_7.evalAns == '5'
                                    ? 'bg-green'
                                    : ''
                                "
                                @click="evalData.l_7.evalAns = '5'"
                              >
                                5
                              </div>
                              <div
                                class="d-flex justify-center align-center border border-1 radio"
                                :class="
                                  evalData && evalData.l_7.evalAns == '4'
                                    ? 'bg-green'
                                    : ''
                                "
                                @click="evalData.l_7.evalAns = '4'"
                              >
                                4
                              </div>
                              <div
                                class="d-flex justify-center align-center border border-1 radio"
                                :class="
                                  evalData && evalData.l_7.evalAns == '3'
                                    ? 'bg-green'
                                    : ''
                                "
                                @click="evalData.l_7.evalAns = '3'"
                              >
                                3
                              </div>
                              <div
                                class="d-flex justify-center align-center border border-1 radio"
                                :class="
                                  evalData && evalData.l_7.evalAns == '2'
                                    ? 'bg-green'
                                    : ''
                                "
                                @click="evalData.l_7.evalAns = '2'"
                              >
                                2
                              </div>
                              <div
                                class="d-flex justify-center align-center border border-1 radio"
                                :class="
                                  evalData && evalData.l_7.evalAns == '1'
                                    ? 'bg-green'
                                    : ''
                                "
                                @click="evalData.l_7.evalAns = '1'"
                              >
                                1
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>

                  <div>
                    <div class="text-subtitle-1 font-weight-bold my-1">
                      III. PLACEMENT AND POTENTIAL
                    </div>
                    <div>
                      <div>
                        <div>
                          <div
                            class="text-subtitle-1 font-weight-bold d-flex ga-2"
                          >
                            <div>13.</div>
                            <div class="font-weight-bold">Job Assignment</div>
                          </div>
                          <div class="d-flex justify-space-between">
                            <div class="ml-5">
                              a.
                              {{ evalData && evalData.m_1.question }}
                            </div>
                            <div class="d-flex ga-4">
                              <div
                                class="d-flex justify-center align-center border border-1 radio"
                                :class="
                                  evalData && evalData.m_1.evalAns == 'Yes'
                                    ? 'bg-green'
                                    : ''
                                "
                                @click="evalData.m_1.evalAns = 'Yes'"
                              >
                                Yes
                              </div>
                              <div
                                class="d-flex justify-center align-center border border-1 radio"
                                :class="
                                  evalData && evalData.m_1.evalAns == 'No'
                                    ? 'bg-green'
                                    : ''
                                "
                                @click="evalData.m_1.evalAns = 'No'"
                              >
                                No
                              </div>
                            </div>
                          </div>
                          <div class="d-flex justify-space-between">
                            <div class="ml-5">
                              {{ evalData && evalData.m_2.question }}
                            </div>
                            <div
                              class=""
                              v-if="
                                evalData && evalData['m_1']?.evalAns == 'No'
                              "
                            >
                              <template v-if="evalData">
                                <v-textarea
                                  rows="5"
                                  variant="outlined"
                                  :rules="[formRules.required]"
                                  :placeholder="
                                    evalData['m_1']?.evalAns == 'No'
                                      ? 'Type Here'
                                      : ''
                                  "
                                  v-model="evalData['m_2'].evalAns"
                                  :disabled="
                                    evalData['m_1']?.evalAns == 'Yes' ||
                                    evalData['m_1']?.evalAns == null
                                  "
                                />
                              </template>
                            </div>
                          </div>
                        </div>
                        <div>
                          <div
                            class="text-subtitle-1 font-weight-bold d-flex ga-2"
                          >
                            <div>14.</div>
                            <div class="font-weight-bold">
                              Overall Qualities
                            </div>
                          </div>

                          <div class="d-flex justify-space-between">
                            <div class="ml-5">
                              a. {{ evalData && evalData.n_1.question }}
                            </div>
                            <div class="">
                              <template v-if="evalData">
                                <v-textarea
                                  :rules="[formRules.required]"
                                  rows="5"
                                  variant="outlined"
                                  placeholder="Type Here"
                                  v-model="evalData['n_1'].evalAns"
                                />
                              </template>
                            </div>
                          </div>
                          <div class="d-flex justify-space-between">
                            <div class="ml-5">
                              b. {{ evalData && evalData.n_2.question }}
                            </div>
                            <div class="">
                              <template v-if="evalData">
                                <v-textarea
                                  rows="5"
                                  :rules="[formRules.required]"
                                  variant="outlined"
                                  placeholder="Type Here"
                                  v-model="evalData['n_2'].evalAns"
                                />
                              </template>
                            </div>
                          </div>

                          <div class="d-flex justify-space-between">
                            <div class="ml-5">
                              c. {{ evalData && evalData.n_3.question }}
                            </div>
                            <div class="">
                              <template v-if="evalData">
                                <v-textarea
                                  :rules="[formRules.required]"
                                  rows="5"
                                  class="text-caption"
                                  variant="outlined"
                                  placeholder="Type Here"
                                  v-model="evalData['n_3'].evalAns"
                                />
                              </template>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </v-col>
              </v-row>
            </v-container>
          </v-card-text>
          <v-divider></v-divider>

          <v-card-actions class="pa-2 mr-4">
            <v-spacer></v-spacer>
            <v-btn outlined @click="closeD()">
              <v-icon>mdi-close-circle-outline</v-icon>
              Cancel
            </v-btn>
            <v-btn
              :color="$vuetify.theme.themes.light.submitBtnsGreen"
              class="white--text"
              density="comfortable"
              variant="flat"
              :disabled="btnLoading"
              :loading="btnLoading"
              @click="action == 'Add' ? save() : update()"
            >
              <v-icon>mdi-check-circle</v-icon>
              Submit Evaluation
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-form>
    </v-dialog>

    <fade-away-message-component
      displayType="default"
      v-model="fadeAwayMessage.show"
      :message="fadeAwayMessage.message"
      :header="fadeAwayMessage.header"
      :type="fadeAwayMessage.type"
    ></fade-away-message-component>
  </div>
</template>

<script>
import eventBus from "@/eventBus";
export default {
  props: {
    data: Object,
    action: String,
    title: String,
    typeToSave: String,
  },
  data() {
    return {
      dialog: false,
      showDatePicker: false,
      btnLoading: false,
      name: null,
      hasTemplate: false,
      template_file: null,
      tmp_filename: null,
      reupload: false,
      deletedFile: null,
      quality_of_work: null,
      punctuality: null,
      initiative: null,
      teamwork: null,

      comments: null,
      evalData: null,
      fadeAwayMessage: {
        show: false,
        type: "success",
        header: "Successfully Added!",
        message: "",
        top: 10,
      },
    };
  },
  computed: {
    getProgramID() {
      return this.data && this.data.program_id;
    },
    getEvaluator() {
      let evaluator = null;
      if (this.$store.state.user.usertype.id == 7) {
        evaluator = "Organization";
      }
      if (this.$store.state.user.usertype.id == 9) {
        evaluator = "Field Officer";
      }

      return evaluator;
    },
  },
  watch: {
    data: {
      handler(data) {
        this.dialog = true;
        this.initialize();
        this.$refs.EvaluationFormRef.resetValidation();
        this.evalData = null;
        console.log(this.$store.state.user);
        console.log("EVAL", data);
        if (data.id) {
          this.name = data.name;
        } else {
          this.$refs.EvaluationFormRef.reset();
        }
      },
      deep: true,
    },
  },
  methods: {
    setValue(type, score) {
      if (type == "quality of work") {
        this.quality_of_work = score;
      }
      if (type == "punctuality") {
        this.punctuality = score;
      }
      if (type == "initiative") {
        this.initiative = score;
      }
      if (type == "teamwork") {
        this.teamwork = score;
      }
    },

    initialize() {
      // this.getPrograms();
      this.axiosCall("/evaluation-util/" + this.data.program_id, "GET").then(
        (res) => {
          console.log(res.data);
          this.evalData = res.data;
        },
      );
    },

    reuploadItem() {
      this.reupload = true;
      this.deletedFile = this.tmp_filename;
      this.tmp_filename = null;
    },

    undoReupload() {
      this.reupload = false;
      this.tmp_filename = this.deletedFile;
      this.deletedFile = null;
    },

    viewItem() {
      console.log("View item", this.tmp_filename);
    },

    saveDate() {
      if (this.valid_until) {
        this.valid_until = this.formatDate3(this.valid_until);
      }

      this.showDatePicker = false;
    },

    // deleteFile() {
    //   console.log(typeof this.moa_file);
    //   if (typeof this.moa_file == "string") {
    //     this.deletedFile = this.moa_file;
    //   }

    //   this.moa_file = null;
    //   this.file_desc = null;
    //   this.valid_until = null;
    // },

    async save() {
      this.btnLoading = true;
      let formValid = await this.$refs.EvaluationFormRef.validate();
      // console.log("VALID", formValid, this.evalData);
      if (formValid.valid) {
        if (this.getProgramID == "1" || this.getProgramID == "2") {
          this.proceedIT();
        }
        if (this.getProgramID == "5") {
          this.proceedBPA();
        }
      }
    },

    proceedIT() {
      let valid = true;
      for (const key in this.evalData) {
        // console.log(key, this.evalData[key]);
        if (this.evalData[key].evalAns == null) {
          valid = false;
          break;
        }
      }
      if (!valid) {
        this.btnLoading = false;
        this.fadeAwayMessage.show = true;
        this.fadeAwayMessage.type = "error";
        this.fadeAwayMessage.message = "Please fill up all fields!";
        this.fadeAwayMessage.header = "System Message";
      } else {
        let data = {
          evaluation: JSON.stringify(this.evalData),
          student_id: this.data.id,
          evaluated_by: this.getEvaluator,
        };

        this.axiosCall("/organization/student-evaluation", "POST", data).then(
          (res) => {
            if (res.data.status == 201) {
              this.btnLoading = false;
              this.fadeAwayMessage.show = true;
              this.fadeAwayMessage.type = "success";
              this.fadeAwayMessage.message = res.data.msg;
              this.fadeAwayMessage.header = "System Message";
              this.closeD();
            } else {
              this.btnLoading = false;
              this.fadeAwayMessage.show = true;
              this.fadeAwayMessage.type = "error";
              this.fadeAwayMessage.message = res.data.msg;
              this.fadeAwayMessage.header = "System Message";
            }
          },
        );
      }
    },

    proceedBPA() {
      let valid = true;
      for (const key in this.evalData) {
        // console.log(this.evalData[key]);
        if (key == "m_1" && this.evalData["m_1"].evalAns == "No") {
          if (this.evalData["m_1"].evalAns == null) {
            valid = false;
            break;
          }
        } else {
          if (this.evalData[key].evalAns == null) {
            valid = false;
            break;
          }
        }
      }
      if (!valid) {
        this.btnLoading = false;
        this.fadeAwayMessage.show = true;
        this.fadeAwayMessage.type = "error";
        this.fadeAwayMessage.message = "Please fill up all fields!";
        this.fadeAwayMessage.header = "System Message";
      } else {
        let data = {
          evaluation: JSON.stringify(this.evalData),
          student_id: this.data.id,
          evaluated_by: this.getEvaluator,
        };

        this.axiosCall("/organization/student-evaluation", "POST", data).then(
          (res) => {
            if (res.data.status == 201) {
              this.btnLoading = false;
              this.fadeAwayMessage.show = true;
              this.fadeAwayMessage.type = "success";
              this.fadeAwayMessage.message = res.data.msg;
              this.fadeAwayMessage.header = "System Message";
              this.closeD();
            } else {
              this.btnLoading = false;
              this.fadeAwayMessage.show = true;
              this.fadeAwayMessage.type = "error";
              this.fadeAwayMessage.message = res.data.msg;
              this.fadeAwayMessage.header = "System Message";
            }
          },
        );
      }
    },

    closeD() {
      eventBus.emit("closeInternEvaluationDialog", true);
      this.btnLoading = false;
      this.dialog = false;
    },

    getPrograms() {
      this.axiosCall("/program", "GET").then((res) => {
        this.programsList = res.data;
      });
    },
  },
};
</script>

<style scoped>
.tbl {
  width: 100%;
  border-collapse: collapse;
  border: 1px solid black;
}

.tbl tbody td {
  border: 1px solid black;
}

.radio {
  width: 20px;
  height: 20px;
  font-size: 8px;
  border-radius: 100%;
  cursor: pointer;
}
</style>
